import React from 'react'
import createSvgIcon from './../helper'

const fragment = (
  <React.Fragment>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 2421 2422"
      id="vector">
      <g
        id="group"
        transform="translate(143 100)">
        <path
          id="path"
          d="M 952.5 0 L 959 0.5 L 952.5 1 L 952.5 0 Z"
          fill="currentColor"
          fillOpacity="0.6862745"
          stroke="currentColor"
          strokeOpacity="0.6862745"
          strokeWidth="1"/>
        <path
          id="path_1"
          d="M 990.5 0 L 997 0.5 L 990.5 1 L 990.5 0 Z"
          fill="currentColor"
          fillOpacity="0.6862745"
          stroke="currentColor"
          strokeOpacity="0.6862745"
          strokeWidth="1"/>
        <path
          id="path_2"
          d="M 936.5 1 L 939 1.5 L 936.5 2 L 936.5 1 Z"
          fill="currentColor"
          fillOpacity="0.6862745"
          stroke="currentColor"
          strokeOpacity="0.6862745"
          strokeWidth="1"/>
        <path
          id="path_3"
          d="M 1010.5 1 L 1013 1.5 L 1010.5 2 L 1010.5 1 Z"
          fill="currentColor"
          fillOpacity="0.6862745"
          stroke="currentColor"
          strokeOpacity="0.6862745"
          strokeWidth="1"/>
        <path
          id="path_4"
          d="M 1022.5 2 L 1025 2.5 L 1022.5 3 L 1022.5 2 Z"
          fill="currentColor"
          fillOpacity="0.6862745"
          stroke="currentColor"
          strokeOpacity="0.6862745"
          strokeWidth="1"/>
        <path
          id="path_5"
          d="M 1292.5 115 L 1293.5 117 L 1292.5 115 Z"
          fill="currentColor"
          fillOpacity="0.6862745"
          stroke="currentColor"
          strokeOpacity="0.6862745"
          strokeWidth="1"/>
        <path
          id="path_6"
          d="M 648.5 121 L 647.5 123 L 648.5 121 Z"
          fill="currentColor"
          fillOpacity="0.6862745"
          stroke="currentColor"
          strokeOpacity="0.6862745"
          strokeWidth="1"/>
        <path
          id="path_7"
          d="M 1299.5 121 L 1300.5 123 L 1299.5 121 Z"
          fill="currentColor"
          fillOpacity="0.6862745"
          stroke="currentColor"
          strokeOpacity="0.6862745"
          strokeWidth="1"/>
        <path
          id="path_8"
          d="M 640.5 128 L 639.5 130 L 640.5 128 Z"
          fill="currentColor"
          fillOpacity="0.6862745"
          stroke="currentColor"
          strokeOpacity="0.6862745"
          strokeWidth="1"/>
        <path
          id="path_9"
          d="M 1309.5 130 L 1312.5 134 L 1309.5 130 Z"
          fill="currentColor"
          fillOpacity="0.6862745"
          stroke="currentColor"
          strokeOpacity="0.6862745"
          strokeWidth="1"/>
        <path
          id="path_10"
          d="M 951.5 133 L 957 133.5 L 951.5 134 L 951.5 133 Z"
          fill="currentColor"
          fillOpacity="0.6862745"
          stroke="currentColor"
          strokeOpacity="0.6862745"
          strokeWidth="1"/>
        <path
          id="path_11"
          d="M 977.5 133 L 984 133.5 L 977.5 134 L 977.5 133 Z"
          fill="currentColor"
          fillOpacity="0.6862745"
          stroke="currentColor"
          strokeOpacity="0.6862745"
          strokeWidth="1"/>
        <path
          id="path_12"
          d="M 936.5 134 L 939 134.5 L 936.5 135 L 936.5 134 Z"
          fill="currentColor"
          fillOpacity="0.6862745"
          stroke="currentColor"
          strokeOpacity="0.6862745"
          strokeWidth="1"/>
        <path
          id="path_13"
          d="M 996.5 134 L 999 134.5 L 996.5 135 L 996.5 134 Z"
          fill="currentColor"
          fillOpacity="0.6862745"
          stroke="currentColor"
          strokeOpacity="0.6862745"
          strokeWidth="1"/>
        <path
          id="path_14"
          d="M 628.5 139 L 612.5 156 L 628.5 139 Z"
          fill="currentColor"
          fillOpacity="0.6862745"
          stroke="currentColor"
          strokeOpacity="0.6862745"
          strokeWidth="1"/>
        <path
          id="path_15"
          d="M 1332.5 153 L 1335.5 157 L 1332.5 153 Z"
          fill="currentColor"
          fillOpacity="0.6862745"
          stroke="currentColor"
          strokeOpacity="0.6862745"
          strokeWidth="1"/>
        <path
          id="path_16"
          d="M 1343.5 165 L 1344.5 167 L 1343.5 165 Z"
          fill="currentColor"
          fillOpacity="0.6862745"
          stroke="currentColor"
          strokeOpacity="0.6862745"
          strokeWidth="1"/>
        <path
          id="path_17"
          d="M 602.5 166 L 600.5 169 L 602.5 166 Z"
          fill="currentColor"
          fillOpacity="0.6862745"
          stroke="currentColor"
          strokeOpacity="0.6862745"
          strokeWidth="1"/>
        <path
          id="path_18"
          d="M 1349.5 172 L 1350.5 174 L 1349.5 172 Z"
          fill="currentColor"
          fillOpacity="0.6862745"
          stroke="currentColor"
          strokeOpacity="0.6862745"
          strokeWidth="1"/>
        <path
          id="path_19"
          d="M 1354.5 178 L 1355.5 180 L 1354.5 178 Z"
          fill="currentColor"
          fillOpacity="0.6862745"
          stroke="currentColor"
          strokeOpacity="0.6862745"
          strokeWidth="1"/>
        <path
          id="path_20"
          d="M 1198.5 216 L 1199.5 218 L 1198.5 216 Z"
          fill="currentColor"
          fillOpacity="0.6862745"
          stroke="currentColor"
          strokeOpacity="0.6862745"
          strokeWidth="1"/>
        <path
          id="path_21"
          d="M 729.5 222 L 728.5 224 L 729.5 222 Z"
          fill="currentColor"
          fillOpacity="0.6862745"
          stroke="currentColor"
          strokeOpacity="0.6862745"
          strokeWidth="1"/>
        <path
          id="path_22"
          d="M 1205.5 222 L 1206.5 224 L 1205.5 222 Z"
          fill="currentColor"
          fillOpacity="0.6862745"
          stroke="currentColor"
          strokeOpacity="0.6862745"
          strokeWidth="1"/>
        <path
          id="path_23"
          d="M 1215.5 231 L 1218.5 235 L 1215.5 231 Z"
          fill="currentColor"
          fillOpacity="0.6862745"
          stroke="currentColor"
          strokeOpacity="0.6862745"
          strokeWidth="1"/>
        <path
          id="path_24"
          d="M 716.5 234 L 710.5 241 L 716.5 234 Z"
          fill="currentColor"
          fillOpacity="0.6862745"
          stroke="currentColor"
          strokeOpacity="0.6862745"
          strokeWidth="1"/>
        <path
          id="path_25"
          d="M 1229.5 245 L 1233.5 250 L 1229.5 245 Z"
          fill="currentColor"
          fillOpacity="0.6862745"
          stroke="currentColor"
          strokeOpacity="0.6862745"
          strokeWidth="1"/>
        <path
          id="path_26"
          d="M 698.5 253 L 697.5 255 L 698.5 253 Z"
          fill="currentColor"
          fillOpacity="0.6862745"
          stroke="currentColor"
          strokeOpacity="0.6862745"
          strokeWidth="1"/>
        <path
          id="path_27"
          d="M 1241.5 258 L 1242.5 260 L 1241.5 258 Z"
          fill="currentColor"
          fillOpacity="0.6862745"
          stroke="currentColor"
          strokeOpacity="0.6862745"
          strokeWidth="1"/>
        <path
          id="path_28"
          d="M 692.5 260 L 691.5 262 L 692.5 260 Z"
          fill="currentColor"
          fillOpacity="0.6862745"
          stroke="currentColor"
          strokeOpacity="0.6862745"
          strokeWidth="1"/>
        <path
          id="path_29"
          d="M 1326.5 454 L 1327 456.5 L 1326 456.5 L 1326.5 454 Z"
          fill="currentColor"
          fillOpacity="0.6862745"
          stroke="currentColor"
          strokeOpacity="0.6862745"
          strokeWidth="1"/>
        <path
          id="path_30"
          d="M 1466.5 457 L 1467 459.5 L 1466 459.5 L 1466.5 457 Z"
          fill="currentColor"
          fillOpacity="0.6862745"
          stroke="currentColor"
          strokeOpacity="0.6862745"
          strokeWidth="1"/>
        <path
          id="path_31"
          d="M 1327.5 468 L 1328 472.5 L 1327 472.5 L 1327.5 468 Z"
          fill="currentColor"
          fillOpacity="0.6862745"
          stroke="currentColor"
          strokeOpacity="0.6862745"
          strokeWidth="1"/>
        <path
          id="path_32"
          d="M 1219.5 526 L 1218.5 528 L 1219.5 526 Z"
          fill="currentColor"
          fillOpacity="0.6862745"
          stroke="currentColor"
          strokeOpacity="0.6862745"
          strokeWidth="1"/>
        <path
          id="path_33"
          d="M 1573.5 527 L 1574.5 529 L 1573.5 527 Z"
          fill="currentColor"
          fillOpacity="0.6862745"
          stroke="currentColor"
          strokeOpacity="0.6862745"
          strokeWidth="1"/>
        <path
          id="path_34"
          d="M 1.5 533 L 99 533.5 L 1.5 534 L 1.5 533 Z"
          fill="currentColor"
          fillOpacity="0.6862745"
          stroke="currentColor"
          strokeOpacity="0.6862745"
          strokeWidth="1"/>
        <path
          id="path_35"
          d="M 1211.5 533 L 1209.5 536 L 1211.5 533 Z"
          fill="currentColor"
          fillOpacity="0.6862745"
          stroke="currentColor"
          strokeOpacity="0.6862745"
          strokeWidth="1"/>
        <path
          id="path_36"
          d="M 1583.5 536 L 1593.5 547 L 1583.5 536 Z"
          fill="currentColor"
          fillOpacity="0.6862745"
          stroke="currentColor"
          strokeOpacity="0.6862745"
          strokeWidth="1"/>
        <path
          id="path_37"
          d="M 1197.5 547 L 1195.5 550 L 1197.5 547 Z"
          fill="currentColor"
          fillOpacity="0.6862745"
          stroke="currentColor"
          strokeOpacity="0.6862745"
          strokeWidth="1"/>
        <path
          id="path_38"
          d="M 1601.5 555 L 1602.5 557 L 1601.5 555 Z"
          fill="currentColor"
          fillOpacity="0.6862745"
          stroke="currentColor"
          strokeOpacity="0.6862745"
          strokeWidth="1"/>
        <path
          id="path_39"
          d="M 1189.5 556 L 1188.5 558 L 1189.5 556 Z"
          fill="currentColor"
          fillOpacity="0.6862745"
          stroke="currentColor"
          strokeOpacity="0.6862745"
          strokeWidth="1"/>
        <path
          id="path_40"
          d="M 171.5 562 L 173.5 565 L 171.5 562 Z"
          fill="currentColor"
          fillOpacity="0.6862745"
          stroke="currentColor"
          strokeOpacity="0.6862745"
          strokeWidth="1"/>
        <path
          id="path_41"
          d="M 180.5 571 L 181.5 573 L 180.5 571 Z"
          fill="currentColor"
          fillOpacity="0.6862745"
          stroke="currentColor"
          strokeOpacity="0.6862745"
          strokeWidth="1"/>
        <path
          id="path_42"
          d="M 224.5 667 L 228 667.5 L 224.5 668 L 224.5 667 Z"
          fill="currentColor"
          fillOpacity="0.6862745"
          stroke="currentColor"
          strokeOpacity="0.6862745"
          strokeWidth="1"/>
        <path
          id="path_43"
          d="M 1128.5 703 L 1129 705.5 L 1128 705.5 L 1128.5 703 Z"
          fill="currentColor"
          fillOpacity="0.6862745"
          stroke="currentColor"
          strokeOpacity="0.6862745"
          strokeWidth="1"/>
        <path
          id="path_44"
          d="M 1666.5 709 L 1667 711.5 L 1666 711.5 L 1666.5 709 Z"
          fill="currentColor"
          fillOpacity="0.6862745"
          stroke="currentColor"
          strokeOpacity="0.6862745"
          strokeWidth="1"/>
        <path
          id="path_45"
          d="M 1667.5 727 L 1668 932.5 L 1667 932.5 L 1667.5 727 Z"
          fill="currentColor"
          fillOpacity="0.6862745"
          stroke="currentColor"
          strokeOpacity="0.6862745"
          strokeWidth="1"/>
        <path
          id="path_46"
          d="M 466.5 915 L 467 917.5 L 466 917.5 L 466.5 915 Z"
          fill="currentColor"
          fillOpacity="0.6862745"
          stroke="currentColor"
          strokeOpacity="0.6862745"
          strokeWidth="1"/>
        <path
          id="path_47"
          d="M 466.5 953 L 467 955.5 L 466 955.5 L 466.5 953 Z"
          fill="currentColor"
          fillOpacity="0.6862745"
          stroke="currentColor"
          strokeOpacity="0.6862745"
          strokeWidth="1"/>
        <path
          id="path_48"
          d="M 402.5 1107 L 401.5 1109 L 402.5 1107 Z"
          fill="currentColor"
          fillOpacity="0.6862745"
          stroke="currentColor"
          strokeOpacity="0.6862745"
          strokeWidth="1"/>
        <path
          id="path_49"
          d="M 393.5 1117 L 384.5 1127 L 393.5 1117 Z"
          fill="currentColor"
          fillOpacity="0.6862745"
          stroke="currentColor"
          strokeOpacity="0.6862745"
          strokeWidth="1"/>
        <path
          id="path_50"
          d="M 375.5 1134 L 374.5 1136 L 375.5 1134 Z"
          fill="currentColor"
          fillOpacity="0.6862745"
          stroke="currentColor"
          strokeOpacity="0.6862745"
          strokeWidth="1"/>
        <path
          id="path_51"
          d="M 216.5 1199 L 220 1199.5 L 216.5 1200 L 216.5 1199 Z"
          fill="currentColor"
          fillOpacity="0.6862745"
          stroke="currentColor"
          strokeOpacity="0.6862745"
          strokeWidth="1"/>
        <path
          id="path_52"
          d="M 200.5 1201 L 201 1227.5 L 200 1227.5 L 200.5 1201 Z"
          fill="currentColor"
          fillOpacity="0.6862745"
          stroke="currentColor"
          strokeOpacity="0.6862745"
          strokeWidth="1"/>
        <path
          id="path_53"
          d="M 685.5 1250 L 686.5 1252 L 685.5 1250 Z"
          fill="currentColor"
          fillOpacity="0.6862745"
          stroke="currentColor"
          strokeOpacity="0.6862745"
          strokeWidth="1"/>
        <path
          id="path_54"
          d="M 715.5 1266 L 718 1266.5 L 715.5 1267 L 715.5 1266 Z"
          fill="currentColor"
          fillOpacity="0.6862745"
          stroke="currentColor"
          strokeOpacity="0.6862745"
          strokeWidth="1"/>
        <path
          id="path_55"
          d="M 2084.5 1266 L 2087 1266.5 L 2084.5 1267 L 2084.5 1266 Z"
          fill="currentColor"
          fillOpacity="0.6862745"
          stroke="currentColor"
          strokeOpacity="0.6862745"
          strokeWidth="1"/>
        <path
          id="path_56"
          d="M 1867.5 1267 L 1868 1701.5 L 1867 1701.5 L 1867.5 1267 Z"
          fill="currentColor"
          fillOpacity="0.6862745"
          stroke="currentColor"
          strokeOpacity="0.6862745"
          strokeWidth="1"/>
        <path
          id="path_57"
          d="M 174.5 1293 L 173.5 1295 L 174.5 1293 Z"
          fill="currentColor"
          fillOpacity="0.6862745"
          stroke="currentColor"
          strokeOpacity="0.6862745"
          strokeWidth="1"/>
        <path
          id="path_58"
          d="M 1533.5 1665 L 1534 1667.5 L 1533 1667.5 L 1533.5 1665 Z"
          fill="currentColor"
          fillOpacity="0.6862745"
          stroke="currentColor"
          strokeOpacity="0.6862745"
          strokeWidth="1"/>
        <path
          id="path_59"
          d="M 1667.5 1700 L 1668 1705.5 L 1667 1705.5 L 1667.5 1700 Z"
          fill="currentColor"
          fillOpacity="0.6862745"
          stroke="currentColor"
          strokeOpacity="0.6862745"
          strokeWidth="1"/>
        <path
          id="path_60"
          d="M 934.5 1703 L 935 1710.5 L 934 1710.5 L 934.5 1703 Z"
          fill="currentColor"
          fillOpacity="0.6862745"
          stroke="currentColor"
          strokeOpacity="0.6862745"
          strokeWidth="1"/>
        <path
          id="path_61"
          d="M 1134.5 1706 L 1135 1709.5 L 1134 1709.5 L 1134.5 1706 Z"
          fill="currentColor"
          fillOpacity="0.6862745"
          stroke="currentColor"
          strokeOpacity="0.6862745"
          strokeWidth="1"/>
        <path
          id="path_62"
          d="M 1135.5 1719 L 1136 1721.5 L 1135 1721.5 L 1135.5 1719 Z"
          fill="currentColor"
          fillOpacity="0.6862745"
          stroke="currentColor"
          strokeOpacity="0.6862745"
          strokeWidth="1"/>
        <path
          id="path_63"
          d="M 1866.5 1720 L 1867 1722.5 L 1866 1722.5 L 1866.5 1720 Z"
          fill="currentColor"
          fillOpacity="0.6862745"
          stroke="currentColor"
          strokeOpacity="0.6862745"
          strokeWidth="1"/>
        <path
          id="path_64"
          d="M 935.5 1724 L 936 1726.5 L 935 1726.5 L 935.5 1724 Z"
          fill="currentColor"
          fillOpacity="0.6862745"
          stroke="currentColor"
          strokeOpacity="0.6862745"
          strokeWidth="1"/>
        <path
          id="path_65"
          d="M 1302.5 1743 L 1304.5 1746 L 1302.5 1743 Z"
          fill="currentColor"
          fillOpacity="0.6862745"
          stroke="currentColor"
          strokeOpacity="0.6862745"
          strokeWidth="1"/>
        <path
          id="path_66"
          d="M 1495.5 1747 L 1494.5 1749 L 1495.5 1747 Z"
          fill="currentColor"
          fillOpacity="0.6862745"
          stroke="currentColor"
          strokeOpacity="0.6862745"
          strokeWidth="1"/>
        <path
          id="path_67"
          d="M 1308.5 1749 L 1310.5 1752 L 1308.5 1749 Z"
          fill="currentColor"
          fillOpacity="0.6862745"
          stroke="currentColor"
          strokeOpacity="0.6862745"
          strokeWidth="1"/>
        <path
          id="path_68"
          d="M 1390.5 1786 L 1394 1786.5 L 1390.5 1787 L 1390.5 1786 Z"
          fill="currentColor"
          fillOpacity="0.6862745"
          stroke="currentColor"
          strokeOpacity="0.6862745"
          strokeWidth="1"/>
        <path
          id="path_69"
          d="M 1407.5 1786 L 1411 1786.5 L 1407.5 1787 L 1407.5 1786 Z"
          fill="currentColor"
          fillOpacity="0.6862745"
          stroke="currentColor"
          strokeOpacity="0.6862745"
          strokeWidth="1"/>
        <path
          id="path_70"
          d="M 1191.5 1855 L 1192.5 1857 L 1191.5 1855 Z"
          fill="currentColor"
          fillOpacity="0.6862745"
          stroke="currentColor"
          strokeOpacity="0.6862745"
          strokeWidth="1"/>
        <path
          id="path_71"
          d="M 1196.5 1861 L 1197.5 1863 L 1196.5 1861 Z"
          fill="currentColor"
          fillOpacity="0.6862745"
          stroke="currentColor"
          strokeOpacity="0.6862745"
          strokeWidth="1"/>
        <path
          id="path_72"
          d="M 1600.5 1869 L 1596.5 1874 L 1600.5 1869 Z"
          fill="currentColor"
          fillOpacity="0.6862745"
          stroke="currentColor"
          strokeOpacity="0.6862745"
          strokeWidth="1"/>
        <path
          id="path_73"
          d="M 1207.5 1873 L 1212.5 1879 L 1207.5 1873 Z"
          fill="currentColor"
          fillOpacity="0.6862745"
          stroke="currentColor"
          strokeOpacity="0.6862745"
          strokeWidth="1"/>
        <path
          id="path_74"
          d="M 1589.5 1880 L 1586.5 1884 L 1589.5 1880 Z"
          fill="currentColor"
          fillOpacity="0.6862745"
          stroke="currentColor"
          strokeOpacity="0.6862745"
          strokeWidth="1"/>
        <path
          id="path_75"
          d="M 1223.5 1888 L 1224.5 1890 L 1223.5 1888 Z"
          fill="currentColor"
          fillOpacity="0.6862745"
          stroke="currentColor"
          strokeOpacity="0.6862745"
          strokeWidth="1"/>
        <path
          id="path_76"
          d="M 1578.5 1890 L 1577.5 1892 L 1578.5 1890 Z"
          fill="currentColor"
          fillOpacity="0.6862745"
          stroke="currentColor"
          strokeOpacity="0.6862745"
          strokeWidth="1"/>
        <path
          id="path_77"
          d="M 1426.5 1952 L 1429 1952.5 L 1426.5 1953 L 1426.5 1952 Z"
          fill="currentColor"
          fillOpacity="0.6862745"
          stroke="currentColor"
          strokeOpacity="0.6862745"
          strokeWidth="1"/>
        <path
          id="path_78"
          d="M 1388.5 1953 L 1395 1953.5 L 1388.5 1954 L 1388.5 1953 Z"
          fill="currentColor"
          fillOpacity="0.6862745"
          stroke="currentColor"
          strokeOpacity="0.6862745"
          strokeWidth="1"/>
        <path
          id="path_79"
          d="M 1407.5 1953 L 1414 1953.5 L 1407.5 1954 L 1407.5 1953 Z"
          fill="currentColor"
          fillOpacity="0.6862745"
          stroke="currentColor"
          strokeOpacity="0.6862745"
          strokeWidth="1"/>
        <path
          id="path_80"
          d="M 1765.5 1965 L 1764.5 1967 L 1765.5 1965 Z"
          fill="currentColor"
          fillOpacity="0.6862745"
          stroke="currentColor"
          strokeOpacity="0.6862745"
          strokeWidth="1"/>
        <path
          id="path_81"
          d="M 1040.5 1970 L 1041.5 1972 L 1040.5 1970 Z"
          fill="currentColor"
          fillOpacity="0.6862745"
          stroke="currentColor"
          strokeOpacity="0.6862745"
          strokeWidth="1"/>
        <path
          id="path_82"
          d="M 1759.5 1972 L 1758.5 1974 L 1759.5 1972 Z"
          fill="currentColor"
          fillOpacity="0.6862745"
          stroke="currentColor"
          strokeOpacity="0.6862745"
          strokeWidth="1"/>
        <path
          id="path_83"
          d="M 1048.5 1979 L 1051.5 1983 L 1048.5 1979 Z"
          fill="currentColor"
          fillOpacity="0.6862745"
          stroke="currentColor"
          strokeOpacity="0.6862745"
          strokeWidth="1"/>
        <path
          id="path_84"
          d="M 1749.5 1983 L 1745.5 1988 L 1749.5 1983 Z"
          fill="currentColor"
          fillOpacity="0.6862745"
          stroke="currentColor"
          strokeOpacity="0.6862745"
          strokeWidth="1"/>
        <path
          id="path_85"
          d="M 1732.5 2000 L 1729.5 2004 L 1732.5 2000 Z"
          fill="currentColor"
          fillOpacity="0.6862745"
          stroke="currentColor"
          strokeOpacity="0.6862745"
          strokeWidth="1"/>
        <path
          id="path_86"
          d="M 1074.5 2005 L 1076.5 2008 L 1074.5 2005 Z"
          fill="currentColor"
          fillOpacity="0.6862745"
          stroke="currentColor"
          strokeOpacity="0.6862745"
          strokeWidth="1"/>
        <path
          id="path_87"
          d="M 1719.5 2012 L 1718.5 2014 L 1719.5 2012 Z"
          fill="currentColor"
          fillOpacity="0.6862745"
          stroke="currentColor"
          strokeOpacity="0.6862745"
          strokeWidth="1"/>
        <path
          id="path_88"
          d="M 1084.5 2014 L 1085.5 2016 L 1084.5 2014 Z"
          fill="currentColor"
          fillOpacity="0.6862745"
          stroke="currentColor"
          strokeOpacity="0.6862745"
          strokeWidth="1"/>
        <path
          id="path_89"
          d="M 1091.5 2020 L 1092.5 2022 L 1091.5 2020 Z"
          fill="currentColor"
          fillOpacity="0.6862745"
          stroke="currentColor"
          strokeOpacity="0.6862745"
          strokeWidth="1"/>
        <path
          id="path_90"
          d="M 1443.5 2131 L 1446 2131.5 L 1443.5 2132 L 1443.5 2131 Z"
          fill="currentColor"
          fillOpacity="0.6862745"
          stroke="currentColor"
          strokeOpacity="0.6862745"
          strokeWidth="1"/>
        <path
          id="path_91"
          d="M 1368.5 2132 L 1372 2132.5 L 1368.5 2133 L 1368.5 2132 Z"
          fill="currentColor"
          fillOpacity="0.6862745"
          stroke="currentColor"
          strokeOpacity="0.6862745"
          strokeWidth="1"/>
        <path
          id="path_92"
          d="M 1430.5 2132 L 1433 2132.5 L 1430.5 2133 L 1430.5 2132 Z"
          fill="currentColor"
          fillOpacity="0.6862745"
          stroke="currentColor"
          strokeOpacity="0.6862745"
          strokeWidth="1"/>
        <path
          id="path_93"
          d="M 1391.5 2133 L 1410 2133.5 L 1391.5 2134 L 1391.5 2133 Z"
          fill="currentColor"
          fillOpacity="0.6862745"
          stroke="currentColor"
          strokeOpacity="0.6862745"
          strokeWidth="1"/>
        <path
          id="path_94"
          d="M 687.5 91 L 686.5 93 L 687.5 91 Z"
          fill="currentColor"
          fillOpacity="0.8862745"
          stroke="currentColor"
          strokeOpacity="0.8862745"
          strokeWidth="1"/>
        <path
          id="path_95"
          d="M 1265.5 94 L 1266.5 96 L 1265.5 94 Z"
          fill="currentColor"
          fillOpacity="0.8862745"
          stroke="currentColor"
          strokeOpacity="0.8862745"
          strokeWidth="1"/>
        <path
          id="path_96"
          d="M 680.5 96 L 679.5 98 L 680.5 96 Z"
          fill="currentColor"
          fillOpacity="0.8862745"
          stroke="currentColor"
          strokeOpacity="0.8862745"
          strokeWidth="1"/>
        <path
          id="path_97"
          d="M 1269.5 97 L 1270.5 99 L 1269.5 97 Z"
          fill="currentColor"
          fillOpacity="0.8862745"
          stroke="currentColor"
          strokeOpacity="0.8862745"
          strokeWidth="1"/>
        <path
          id="path_98"
          d="M 676.5 99 L 675.5 101 L 676.5 99 Z"
          fill="currentColor"
          fillOpacity="0.8862745"
          stroke="currentColor"
          strokeOpacity="0.8862745"
          strokeWidth="1"/>
        <path
          id="path_99"
          d="M 1273.5 100 L 1274.5 102 L 1273.5 100 Z"
          fill="currentColor"
          fillOpacity="0.8862745"
          stroke="currentColor"
          strokeOpacity="0.8862745"
          strokeWidth="1"/>
        <path
          id="path_100"
          d="M 672.5 102 L 671.5 104 L 672.5 102 Z"
          fill="currentColor"
          fillOpacity="0.8862745"
          stroke="currentColor"
          strokeOpacity="0.8862745"
          strokeWidth="1"/>
        <path
          id="path_101"
          d="M 1277.5 103 L 1278.5 105 L 1277.5 103 Z"
          fill="currentColor"
          fillOpacity="0.8862745"
          stroke="currentColor"
          strokeOpacity="0.8862745"
          strokeWidth="1"/>
        <path
          id="path_102"
          d="M 668.5 105 L 667.5 107 L 668.5 105 Z"
          fill="currentColor"
          fillOpacity="0.8862745"
          stroke="currentColor"
          strokeOpacity="0.8862745"
          strokeWidth="1"/>
        <path
          id="path_103"
          d="M 1282.5 107 L 1283.5 109 L 1282.5 107 Z"
          fill="currentColor"
          fillOpacity="0.8862745"
          stroke="currentColor"
          strokeOpacity="0.8862745"
          strokeWidth="1"/>
        <path
          id="path_104"
          d="M 663.5 109 L 662.5 111 L 663.5 109 Z"
          fill="currentColor"
          fillOpacity="0.8862745"
          stroke="currentColor"
          strokeOpacity="0.8862745"
          strokeWidth="1"/>
        <path
          id="path_105"
          d="M 1287.5 111 L 1289.5 114 L 1287.5 111 Z"
          fill="currentColor"
          fillOpacity="0.8862745"
          stroke="currentColor"
          strokeOpacity="0.8862745"
          strokeWidth="1"/>
        <path
          id="path_106"
          d="M 658.5 113 L 657.5 115 L 658.5 113 Z"
          fill="currentColor"
          fillOpacity="0.8862745"
          stroke="currentColor"
          strokeOpacity="0.8862745"
          strokeWidth="1"/>
        <path
          id="path_107"
          d="M 653.5 117 L 651.5 120 L 653.5 117 Z"
          fill="currentColor"
          fillOpacity="0.8862745"
          stroke="currentColor"
          strokeOpacity="0.8862745"
          strokeWidth="1"/>
        <path
          id="path_108"
          d="M 1294.5 117 L 1296.5 120 L 1294.5 117 Z"
          fill="currentColor"
          fillOpacity="0.8862745"
          stroke="currentColor"
          strokeOpacity="0.8862745"
          strokeWidth="1"/>
        <path
          id="path_109"
          d="M 646.5 123 L 644.5 126 L 646.5 123 Z"
          fill="currentColor"
          fillOpacity="0.8862745"
          stroke="currentColor"
          strokeOpacity="0.8862745"
          strokeWidth="1"/>
        <path
          id="path_110"
          d="M 1301.5 123 L 1304.5 127 L 1301.5 123 Z"
          fill="currentColor"
          fillOpacity="0.8862745"
          stroke="currentColor"
          strokeOpacity="0.8862745"
          strokeWidth="1"/>
        <path
          id="path_111"
          d="M 638.5 130 L 634.5 135 L 638.5 130 Z"
          fill="currentColor"
          fillOpacity="0.8862745"
          stroke="currentColor"
          strokeOpacity="0.8862745"
          strokeWidth="1"/>
        <path
          id="path_112"
          d="M 1313.5 134 L 1331.5 153 L 1313.5 134 Z"
          fill="currentColor"
          fillOpacity="0.8862745"
          stroke="currentColor"
          strokeOpacity="0.8862745"
          strokeWidth="1"/>
        <path
          id="path_113"
          d="M 607.5 161 L 603.5 166 L 607.5 161 Z"
          fill="currentColor"
          fillOpacity="0.8862745"
          stroke="currentColor"
          strokeOpacity="0.8862745"
          strokeWidth="1"/>
        <path
          id="path_114"
          d="M 1339.5 161 L 1342.5 165 L 1339.5 161 Z"
          fill="currentColor"
          fillOpacity="0.8862745"
          stroke="currentColor"
          strokeOpacity="0.8862745"
          strokeWidth="1"/>
        <path
          id="path_115"
          d="M 1346.5 169 L 1348.5 172 L 1346.5 169 Z"
          fill="currentColor"
          fillOpacity="0.8862745"
          stroke="currentColor"
          strokeOpacity="0.8862745"
          strokeWidth="1"/>
        <path
          id="path_116"
          d="M 598.5 171 L 595.5 175 L 598.5 171 Z"
          fill="currentColor"
          fillOpacity="0.8862745"
          stroke="currentColor"
          strokeOpacity="0.8862745"
          strokeWidth="1"/>
        <path
          id="path_117"
          d="M 1352.5 176 L 1353.5 178 L 1352.5 176 Z"
          fill="currentColor"
          fillOpacity="0.8862745"
          stroke="currentColor"
          strokeOpacity="0.8862745"
          strokeWidth="1"/>
        <path
          id="path_118"
          d="M 591.5 179 L 590.5 181 L 591.5 179 Z"
          fill="currentColor"
          fillOpacity="0.8862745"
          stroke="currentColor"
          strokeOpacity="0.8862745"
          strokeWidth="1"/>
        <path
          id="path_119"
          d="M 1357.5 182 L 1358.5 184 L 1357.5 182 Z"
          fill="currentColor"
          fillOpacity="0.8862745"
          stroke="currentColor"
          strokeOpacity="0.8862745"
          strokeWidth="1"/>
        <path
          id="path_120"
          d="M 587.5 184 L 585.5 187 L 587.5 184 Z"
          fill="currentColor"
          fillOpacity="0.8862745"
          stroke="currentColor"
          strokeOpacity="0.8862745"
          strokeWidth="1"/>
        <path
          id="path_121"
          d="M 1364.5 191 L 1365.5 193 L 1364.5 191 Z"
          fill="currentColor"
          fillOpacity="0.8862745"
          stroke="currentColor"
          strokeOpacity="0.8862745"
          strokeWidth="1"/>
        <path
          id="path_122"
          d="M 579.5 194 L 578.5 196 L 579.5 194 Z"
          fill="currentColor"
          fillOpacity="0.8862745"
          stroke="currentColor"
          strokeOpacity="0.8862745"
          strokeWidth="1"/>
        <path
          id="path_123"
          d="M 763.5 195 L 762.5 197 L 763.5 195 Z"
          fill="currentColor"
          fillOpacity="0.8862745"
          stroke="currentColor"
          strokeOpacity="0.8862745"
          strokeWidth="1"/>
        <path
          id="path_124"
          d="M 1367.5 195 L 1368.5 197 L 1367.5 195 Z"
          fill="currentColor"
          fillOpacity="0.8862745"
          stroke="currentColor"
          strokeOpacity="0.8862745"
          strokeWidth="1"/>
        <path
          id="path_125"
          d="M 1370.5 199 L 1371.5 201 L 1370.5 199 Z"
          fill="currentColor"
          fillOpacity="0.8862745"
          stroke="currentColor"
          strokeOpacity="0.8862745"
          strokeWidth="1"/>
        <path
          id="path_126"
          d="M 756.5 200 L 755.5 202 L 756.5 200 Z"
          fill="currentColor"
          fillOpacity="0.8862745"
          stroke="currentColor"
          strokeOpacity="0.8862745"
          strokeWidth="1"/>
        <path
          id="path_127"
          d="M 1179.5 201 L 1180.5 203 L 1179.5 201 Z"
          fill="currentColor"
          fillOpacity="0.8862745"
          stroke="currentColor"
          strokeOpacity="0.8862745"
          strokeWidth="1"/>
        <path
          id="path_128"
          d="M 570.5 206 L 569.5 208 L 570.5 206 Z"
          fill="currentColor"
          fillOpacity="0.8862745"
          stroke="currentColor"
          strokeOpacity="0.8862745"
          strokeWidth="1"/>
        <path
          id="path_129"
          d="M 748.5 206 L 747.5 208 L 748.5 206 Z"
          fill="currentColor"
          fillOpacity="0.8862745"
          stroke="currentColor"
          strokeOpacity="0.8862745"
          strokeWidth="1"/>
        <path
          id="path_130"
          d="M 1187.5 207 L 1188.5 209 L 1187.5 207 Z"
          fill="currentColor"
          fillOpacity="0.8862745"
          stroke="currentColor"
          strokeOpacity="0.8862745"
          strokeWidth="1"/>
        <path
          id="path_131"
          d="M 744.5 209 L 743.5 211 L 744.5 209 Z"
          fill="currentColor"
          fillOpacity="0.8862745"
          stroke="currentColor"
          strokeOpacity="0.8862745"
          strokeWidth="1"/>
        <path
          id="path_132"
          d="M 1191.5 210 L 1192.5 212 L 1191.5 210 Z"
          fill="currentColor"
          fillOpacity="0.8862745"
          stroke="currentColor"
          strokeOpacity="0.8862745"
          strokeWidth="1"/>
        <path
          id="path_133"
          d="M 739.5 213 L 737.5 216 L 739.5 213 Z"
          fill="currentColor"
          fillOpacity="0.8862745"
          stroke="currentColor"
          strokeOpacity="0.8862745"
          strokeWidth="1"/>
        <path
          id="path_134"
          d="M 1196.5 214 L 1197.5 216 L 1196.5 214 Z"
          fill="currentColor"
          fillOpacity="0.8862745"
          stroke="currentColor"
          strokeOpacity="0.8862745"
          strokeWidth="1"/>
        <path
          id="path_135"
          d="M 563.5 216 L 562.5 218 L 563.5 216 Z"
          fill="currentColor"
          fillOpacity="0.8862745"
          stroke="currentColor"
          strokeOpacity="0.8862745"
          strokeWidth="1"/>
        <path
          id="path_136"
          d="M 733.5 218 L 730.5 222 L 733.5 218 Z"
          fill="currentColor"
          fillOpacity="0.8862745"
          stroke="currentColor"
          strokeOpacity="0.8862745"
          strokeWidth="1"/>
        <path
          id="path_137"
          d="M 1202.5 219 L 1204.5 222 L 1202.5 219 Z"
          fill="currentColor"
          fillOpacity="0.8862745"
          stroke="currentColor"
          strokeOpacity="0.8862745"
          strokeWidth="1"/>
        <path
          id="path_138"
          d="M 724.5 226 L 717.5 234 L 724.5 226 Z"
          fill="currentColor"
          fillOpacity="0.8862745"
          stroke="currentColor"
          strokeOpacity="0.8862745"
          strokeWidth="1"/>
        <path
          id="path_139"
          d="M 1210.5 226 L 1214.5 231 L 1210.5 226 Z"
          fill="currentColor"
          fillOpacity="0.8862745"
          stroke="currentColor"
          strokeOpacity="0.8862745"
          strokeWidth="1"/>
        <path
          id="path_140"
          d="M 709.5 241 L 702.5 249 L 709.5 241 Z"
          fill="currentColor"
          fillOpacity="0.8862745"
          stroke="currentColor"
          strokeOpacity="0.8862745"
          strokeWidth="1"/>
        <path
          id="path_141"
          d="M 1234.5 250 L 1238.5 255 L 1234.5 250 Z"
          fill="currentColor"
          fillOpacity="0.8862745"
          stroke="currentColor"
          strokeOpacity="0.8862745"
          strokeWidth="1"/>
        <path
          id="path_142"
          d="M 696.5 255 L 694.5 258 L 696.5 255 Z"
          fill="currentColor"
          fillOpacity="0.8862745"
          stroke="currentColor"
          strokeOpacity="0.8862745"
          strokeWidth="1"/>
        <path
          id="path_143"
          d="M 1243.5 260 L 1244.5 262 L 1243.5 260 Z"
          fill="currentColor"
          fillOpacity="0.8862745"
          stroke="currentColor"
          strokeOpacity="0.8862745"
          strokeWidth="1"/>
        <path
          id="path_144"
          d="M 690.5 262 L 689.5 264 L 690.5 262 Z"
          fill="currentColor"
          fillOpacity="0.8862745"
          stroke="currentColor"
          strokeOpacity="0.8862745"
          strokeWidth="1"/>
        <path
          id="path_145"
          d="M 1248.5 266 L 1249.5 268 L 1248.5 266 Z"
          fill="currentColor"
          fillOpacity="0.8862745"
          stroke="currentColor"
          strokeOpacity="0.8862745"
          strokeWidth="1"/>
        <path
          id="path_146"
          d="M 686.5 267 L 685.5 269 L 686.5 267 Z"
          fill="currentColor"
          fillOpacity="0.8862745"
          stroke="currentColor"
          strokeOpacity="0.8862745"
          strokeWidth="1"/>
        <path
          id="path_147"
          d="M 1252.5 271 L 1253.5 273 L 1252.5 271 Z"
          fill="currentColor"
          fillOpacity="0.8862745"
          stroke="currentColor"
          strokeOpacity="0.8862745"
          strokeWidth="1"/>
        <path
          id="path_148"
          d="M 682.5 272 L 681.5 274 L 682.5 272 Z"
          fill="currentColor"
          fillOpacity="0.8862745"
          stroke="currentColor"
          strokeOpacity="0.8862745"
          strokeWidth="1"/>
        <path
          id="path_149"
          d="M 679.5 276 L 678.5 278 L 679.5 276 Z"
          fill="currentColor"
          fillOpacity="0.8862745"
          stroke="currentColor"
          strokeOpacity="0.8862745"
          strokeWidth="1"/>
        <path
          id="path_150"
          d="M 1232.5 516 L 1231.5 518 L 1232.5 516 Z"
          fill="currentColor"
          fillOpacity="0.8862745"
          stroke="currentColor"
          strokeOpacity="0.8862745"
          strokeWidth="1"/>
        <path
          id="path_151"
          d="M 1228.5 519 L 1227.5 521 L 1228.5 519 Z"
          fill="currentColor"
          fillOpacity="0.8862745"
          stroke="currentColor"
          strokeOpacity="0.8862745"
          strokeWidth="1"/>
        <path
          id="path_152"
          d="M 1564.5 520 L 1565.5 522 L 1564.5 520 Z"
          fill="currentColor"
          fillOpacity="0.8862745"
          stroke="currentColor"
          strokeOpacity="0.8862745"
          strokeWidth="1"/>
        <path
          id="path_153"
          d="M 1223.5 523 L 1222.5 525 L 1223.5 523 Z"
          fill="currentColor"
          fillOpacity="0.8862745"
          stroke="currentColor"
          strokeOpacity="0.8862745"
          strokeWidth="1"/>
        <path
          id="path_154"
          d="M 1569.5 524 L 1570.5 526 L 1569.5 524 Z"
          fill="currentColor"
          fillOpacity="0.8862745"
          stroke="currentColor"
          strokeOpacity="0.8862745"
          strokeWidth="1"/>
        <path
          id="path_155"
          d="M 1217.5 528 L 1215.5 531 L 1217.5 528 Z"
          fill="currentColor"
          fillOpacity="0.8862745"
          stroke="currentColor"
          strokeOpacity="0.8862745"
          strokeWidth="1"/>
        <path
          id="path_156"
          d="M 1575.5 529 L 1578.5 533 L 1575.5 529 Z"
          fill="currentColor"
          fillOpacity="0.8862745"
          stroke="currentColor"
          strokeOpacity="0.8862745"
          strokeWidth="1"/>
        <path
          id="path_157"
          d="M 1208.5 536 L 1198.5 547 L 1208.5 536 Z"
          fill="currentColor"
          fillOpacity="0.8862745"
          stroke="currentColor"
          strokeOpacity="0.8862745"
          strokeWidth="1"/>
        <path
          id="path_158"
          d="M 1597.5 551 L 1600.5 555 L 1597.5 551 Z"
          fill="currentColor"
          fillOpacity="0.8862745"
          stroke="currentColor"
          strokeOpacity="0.8862745"
          strokeWidth="1"/>
        <path
          id="path_159"
          d="M 159.5 553 L 160.5 555 L 159.5 553 Z"
          fill="currentColor"
          fillOpacity="0.8862745"
          stroke="currentColor"
          strokeOpacity="0.8862745"
          strokeWidth="1"/>
        <path
          id="path_160"
          d="M 1192.5 553 L 1190.5 556 L 1192.5 553 Z"
          fill="currentColor"
          fillOpacity="0.8862745"
          stroke="currentColor"
          strokeOpacity="0.8862745"
          strokeWidth="1"/>
        <path
          id="path_161"
          d="M 167.5 559 L 168.5 561 L 167.5 559 Z"
          fill="currentColor"
          fillOpacity="0.8862745"
          stroke="currentColor"
          strokeOpacity="0.8862745"
          strokeWidth="1"/>
        <path
          id="path_162"
          d="M 1604.5 559 L 1605.5 561 L 1604.5 559 Z"
          fill="currentColor"
          fillOpacity="0.8862745"
          stroke="currentColor"
          strokeOpacity="0.8862745"
          strokeWidth="1"/>
        <path
          id="path_163"
          d="M 1186.5 560 L 1185.5 562 L 1186.5 560 Z"
          fill="currentColor"
          fillOpacity="0.8862745"
          stroke="currentColor"
          strokeOpacity="0.8862745"
          strokeWidth="1"/>
        <path
          id="path_164"
          d="M 1608.5 564 L 1609.5 566 L 1608.5 564 Z"
          fill="currentColor"
          fillOpacity="0.8862745"
          stroke="currentColor"
          strokeOpacity="0.8862745"
          strokeWidth="1"/>
        <path
          id="path_165"
          d="M 174.5 565 L 179.5 571 L 174.5 565 Z"
          fill="currentColor"
          fillOpacity="0.8862745"
          stroke="currentColor"
          strokeOpacity="0.8862745"
          strokeWidth="1"/>
        <path
          id="path_166"
          d="M 1182.5 565 L 1181.5 567 L 1182.5 565 Z"
          fill="currentColor"
          fillOpacity="0.8862745"
          stroke="currentColor"
          strokeOpacity="0.8862745"
          strokeWidth="1"/>
        <path
          id="path_167"
          d="M 1179.5 569 L 1178.5 571 L 1179.5 569 Z"
          fill="currentColor"
          fillOpacity="0.8862745"
          stroke="currentColor"
          strokeOpacity="0.8862745"
          strokeWidth="1"/>
        <path
          id="path_168"
          d="M 1612.5 569 L 1613.5 571 L 1612.5 569 Z"
          fill="currentColor"
          fillOpacity="0.8862745"
          stroke="currentColor"
          strokeOpacity="0.8862745"
          strokeWidth="1"/>
        <path
          id="path_169"
          d="M 183.5 575 L 184.5 577 L 183.5 575 Z"
          fill="currentColor"
          fillOpacity="0.8862745"
          stroke="currentColor"
          strokeOpacity="0.8862745"
          strokeWidth="1"/>
        <path
          id="path_170"
          d="M 1172.5 579 L 1171.5 581 L 1172.5 579 Z"
          fill="currentColor"
          fillOpacity="0.8862745"
          stroke="currentColor"
          strokeOpacity="0.8862745"
          strokeWidth="1"/>
        <path
          id="path_171"
          d="M 410.5 1097 L 409.5 1099 L 410.5 1097 Z"
          fill="currentColor"
          fillOpacity="0.8862745"
          stroke="currentColor"
          strokeOpacity="0.8862745"
          strokeWidth="1"/>
        <path
          id="path_172"
          d="M 406.5 1102 L 404.5 1105 L 406.5 1102 Z"
          fill="currentColor"
          fillOpacity="0.8862745"
          stroke="currentColor"
          strokeOpacity="0.8862745"
          strokeWidth="1"/>
        <path
          id="path_173"
          d="M 400.5 1109 L 397.5 1113 L 400.5 1109 Z"
          fill="currentColor"
          fillOpacity="0.8862745"
          stroke="currentColor"
          strokeOpacity="0.8862745"
          strokeWidth="1"/>
        <path
          id="path_174"
          d="M 379.5 1130 L 376.5 1134 L 379.5 1130 Z"
          fill="currentColor"
          fillOpacity="0.8862745"
          stroke="currentColor"
          strokeOpacity="0.8862745"
          strokeWidth="1"/>
        <path
          id="path_175"
          d="M 371.5 1137 L 369.5 1140 L 371.5 1137 Z"
          fill="currentColor"
          fillOpacity="0.8862745"
          stroke="currentColor"
          strokeOpacity="0.8862745"
          strokeWidth="1"/>
        <path
          id="path_176"
          d="M 365.5 1142 L 364.5 1144 L 365.5 1142 Z"
          fill="currentColor"
          fillOpacity="0.8862745"
          stroke="currentColor"
          strokeOpacity="0.8862745"
          strokeWidth="1"/>
        <path
          id="path_177"
          d="M 361.5 1145 L 360.5 1147 L 361.5 1145 Z"
          fill="currentColor"
          fillOpacity="0.8862745"
          stroke="currentColor"
          strokeOpacity="0.8862745"
          strokeWidth="1"/>
        <path
          id="path_178"
          d="M 357.5 1148 L 356.5 1150 L 357.5 1148 Z"
          fill="currentColor"
          fillOpacity="0.8862745"
          stroke="currentColor"
          strokeOpacity="0.8862745"
          strokeWidth="1"/>
        <path
          id="path_179"
          d="M 681.5 1245 L 682.5 1247 L 681.5 1245 Z"
          fill="currentColor"
          fillOpacity="0.8862745"
          stroke="currentColor"
          strokeOpacity="0.8862745"
          strokeWidth="1"/>
        <path
          id="path_180"
          d="M 2118.5 1247 L 2116.5 1250 L 2118.5 1247 Z"
          fill="currentColor"
          fillOpacity="0.8862745"
          stroke="currentColor"
          strokeOpacity="0.8862745"
          strokeWidth="1"/>
        <path
          id="path_181"
          d="M 690.5 1254 L 691.5 1256 L 690.5 1254 Z"
          fill="currentColor"
          fillOpacity="0.8862745"
          stroke="currentColor"
          strokeOpacity="0.8862745"
          strokeWidth="1"/>
        <path
          id="path_182"
          d="M 2111.5 1254 L 2109.5 1257 L 2111.5 1254 Z"
          fill="currentColor"
          fillOpacity="0.8862745"
          stroke="currentColor"
          strokeOpacity="0.8862745"
          strokeWidth="1"/>
        <path
          id="path_183"
          d="M 177.5 1289 L 176.5 1291 L 177.5 1289 Z"
          fill="currentColor"
          fillOpacity="0.8862745"
          stroke="currentColor"
          strokeOpacity="0.8862745"
          strokeWidth="1"/>
        <path
          id="path_184"
          d="M 172.5 1295 L 162.5 1306 L 172.5 1295 Z"
          fill="currentColor"
          fillOpacity="0.8862745"
          stroke="currentColor"
          strokeOpacity="0.8862745"
          strokeWidth="1"/>
        <path
          id="path_185"
          d="M 158.5 1308 L 157.5 1310 L 158.5 1308 Z"
          fill="currentColor"
          fillOpacity="0.8862745"
          stroke="currentColor"
          strokeOpacity="0.8862745"
          strokeWidth="1"/>
        <path
          id="path_186"
          d="M 154.5 1311 L 153.5 1313 L 154.5 1311 Z"
          fill="currentColor"
          fillOpacity="0.8862745"
          stroke="currentColor"
          strokeOpacity="0.8862745"
          strokeWidth="1"/>
        <path
          id="path_187"
          d="M 1509.5 1730 L 1508.5 1732 L 1509.5 1730 Z"
          fill="currentColor"
          fillOpacity="0.8862745"
          stroke="currentColor"
          strokeOpacity="0.8862745"
          strokeWidth="1"/>
        <path
          id="path_188"
          d="M 1294.5 1733 L 1295.5 1735 L 1294.5 1733 Z"
          fill="currentColor"
          fillOpacity="0.8862745"
          stroke="currentColor"
          strokeOpacity="0.8862745"
          strokeWidth="1"/>
        <path
          id="path_189"
          d="M 1506.5 1734 L 1505.5 1736 L 1506.5 1734 Z"
          fill="currentColor"
          fillOpacity="0.8862745"
          stroke="currentColor"
          strokeOpacity="0.8862745"
          strokeWidth="1"/>
        <path
          id="path_190"
          d="M 1298.5 1738 L 1299.5 1740 L 1298.5 1738 Z"
          fill="currentColor"
          fillOpacity="0.8862745"
          stroke="currentColor"
          strokeOpacity="0.8862745"
          strokeWidth="1"/>
        <path
          id="path_191"
          d="M 1502.5 1739 L 1500.5 1742 L 1502.5 1739 Z"
          fill="currentColor"
          fillOpacity="0.8862745"
          stroke="currentColor"
          strokeOpacity="0.8862745"
          strokeWidth="1"/>
        <path
          id="path_192"
          d="M 1305.5 1746 L 1307.5 1749 L 1305.5 1746 Z"
          fill="currentColor"
          fillOpacity="0.8862745"
          stroke="currentColor"
          strokeOpacity="0.8862745"
          strokeWidth="1"/>
        <path
          id="path_193"
          d="M 1489.5 1752 L 1486.5 1756 L 1489.5 1752 Z"
          fill="currentColor"
          fillOpacity="0.8862745"
          stroke="currentColor"
          strokeOpacity="0.8862745"
          strokeWidth="1"/>
        <path
          id="path_194"
          d="M 1314.5 1754 L 1316.5 1757 L 1314.5 1754 Z"
          fill="currentColor"
          fillOpacity="0.8862745"
          stroke="currentColor"
          strokeOpacity="0.8862745"
          strokeWidth="1"/>
        <path
          id="path_195"
          d="M 1482.5 1758 L 1481.5 1760 L 1482.5 1758 Z"
          fill="currentColor"
          fillOpacity="0.8862745"
          stroke="currentColor"
          strokeOpacity="0.8862745"
          strokeWidth="1"/>
        <path
          id="path_196"
          d="M 1178.5 1838 L 1179.5 1840 L 1178.5 1838 Z"
          fill="currentColor"
          fillOpacity="0.8862745"
          stroke="currentColor"
          strokeOpacity="0.8862745"
          strokeWidth="1"/>
        <path
          id="path_197"
          d="M 1622.5 1842 L 1621.5 1844 L 1622.5 1842 Z"
          fill="currentColor"
          fillOpacity="0.8862745"
          stroke="currentColor"
          strokeOpacity="0.8862745"
          strokeWidth="1"/>
        <path
          id="path_198"
          d="M 1183.5 1845 L 1184.5 1847 L 1183.5 1845 Z"
          fill="currentColor"
          fillOpacity="0.8862745"
          stroke="currentColor"
          strokeOpacity="0.8862745"
          strokeWidth="1"/>
        <path
          id="path_199"
          d="M 1186.5 1849 L 1187.5 1851 L 1186.5 1849 Z"
          fill="currentColor"
          fillOpacity="0.8862745"
          stroke="currentColor"
          strokeOpacity="0.8862745"
          strokeWidth="1"/>
        <path
          id="path_200"
          d="M 1189.5 1853 L 1190.5 1855 L 1189.5 1853 Z"
          fill="currentColor"
          fillOpacity="0.8862745"
          stroke="currentColor"
          strokeOpacity="0.8862745"
          strokeWidth="1"/>
        <path
          id="path_201"
          d="M 1194.5 1859 L 1195.5 1861 L 1194.5 1859 Z"
          fill="currentColor"
          fillOpacity="0.8862745"
          stroke="currentColor"
          strokeOpacity="0.8862745"
          strokeWidth="1"/>
        <path
          id="path_202"
          d="M 1609.5 1859 L 1608.5 1861 L 1609.5 1859 Z"
          fill="currentColor"
          fillOpacity="0.8862745"
          stroke="currentColor"
          strokeOpacity="0.8862745"
          strokeWidth="1"/>
        <path
          id="path_203"
          d="M 1604.5 1865 L 1601.5 1869 L 1604.5 1865 Z"
          fill="currentColor"
          fillOpacity="0.8862745"
          stroke="currentColor"
          strokeOpacity="0.8862745"
          strokeWidth="1"/>
        <path
          id="path_204"
          d="M 1200.5 1866 L 1206.5 1873 L 1200.5 1866 Z"
          fill="currentColor"
          fillOpacity="0.8862745"
          stroke="currentColor"
          strokeOpacity="0.8862745"
          strokeWidth="1"/>
        <path
          id="path_205"
          d="M 1213.5 1879 L 1219.5 1886 L 1213.5 1879 Z"
          fill="currentColor"
          fillOpacity="0.8862745"
          stroke="currentColor"
          strokeOpacity="0.8862745"
          strokeWidth="1"/>
        <path
          id="path_206"
          d="M 1585.5 1884 L 1581.5 1889 L 1585.5 1884 Z"
          fill="currentColor"
          fillOpacity="0.8862745"
          stroke="currentColor"
          strokeOpacity="0.8862745"
          strokeWidth="1"/>
        <path
          id="path_207"
          d="M 1225.5 1890 L 1226.5 1892 L 1225.5 1890 Z"
          fill="currentColor"
          fillOpacity="0.8862745"
          stroke="currentColor"
          strokeOpacity="0.8862745"
          strokeWidth="1"/>
        <path
          id="path_208"
          d="M 1576.5 1892 L 1575.5 1894 L 1576.5 1892 Z"
          fill="currentColor"
          fillOpacity="0.8862745"
          stroke="currentColor"
          strokeOpacity="0.8862745"
          strokeWidth="1"/>
        <path
          id="path_209"
          d="M 1231.5 1895 L 1232.5 1897 L 1231.5 1895 Z"
          fill="currentColor"
          fillOpacity="0.8862745"
          stroke="currentColor"
          strokeOpacity="0.8862745"
          strokeWidth="1"/>
        <path
          id="path_210"
          d="M 1571.5 1896 L 1570.5 1898 L 1571.5 1896 Z"
          fill="currentColor"
          fillOpacity="0.8862745"
          stroke="currentColor"
          strokeOpacity="0.8862745"
          strokeWidth="1"/>
        <path
          id="path_211"
          d="M 1235.5 1898 L 1236.5 1900 L 1235.5 1898 Z"
          fill="currentColor"
          fillOpacity="0.8862745"
          stroke="currentColor"
          strokeOpacity="0.8862745"
          strokeWidth="1"/>
        <path
          id="path_212"
          d="M 1793.5 1928 L 1792.5 1930 L 1793.5 1928 Z"
          fill="currentColor"
          fillOpacity="0.8862745"
          stroke="currentColor"
          strokeOpacity="0.8862745"
          strokeWidth="1"/>
        <path
          id="path_213"
          d="M 1017.5 1941 L 1018.5 1943 L 1017.5 1941 Z"
          fill="currentColor"
          fillOpacity="0.8862745"
          stroke="currentColor"
          strokeOpacity="0.8862745"
          strokeWidth="1"/>
        <path
          id="path_214"
          d="M 1783.5 1942 L 1782.5 1944 L 1783.5 1942 Z"
          fill="currentColor"
          fillOpacity="0.8862745"
          stroke="currentColor"
          strokeOpacity="0.8862745"
          strokeWidth="1"/>
        <path
          id="path_215"
          d="M 1020.5 1945 L 1021.5 1947 L 1020.5 1945 Z"
          fill="currentColor"
          fillOpacity="0.8862745"
          stroke="currentColor"
          strokeOpacity="0.8862745"
          strokeWidth="1"/>
        <path
          id="path_216"
          d="M 1780.5 1946 L 1779.5 1948 L 1780.5 1946 Z"
          fill="currentColor"
          fillOpacity="0.8862745"
          stroke="currentColor"
          strokeOpacity="0.8862745"
          strokeWidth="1"/>
        <path
          id="path_217"
          d="M 1023.5 1949 L 1024.5 1951 L 1023.5 1949 Z"
          fill="currentColor"
          fillOpacity="0.8862745"
          stroke="currentColor"
          strokeOpacity="0.8862745"
          strokeWidth="1"/>
        <path
          id="path_218"
          d="M 1027.5 1954 L 1028.5 1956 L 1027.5 1954 Z"
          fill="currentColor"
          fillOpacity="0.8862745"
          stroke="currentColor"
          strokeOpacity="0.8862745"
          strokeWidth="1"/>
        <path
          id="path_219"
          d="M 1773.5 1955 L 1772.5 1957 L 1773.5 1955 Z"
          fill="currentColor"
          fillOpacity="0.8862745"
          stroke="currentColor"
          strokeOpacity="0.8862745"
          strokeWidth="1"/>
        <path
          id="path_220"
          d="M 1031.5 1959 L 1032.5 1961 L 1031.5 1959 Z"
          fill="currentColor"
          fillOpacity="0.8862745"
          stroke="currentColor"
          strokeOpacity="0.8862745"
          strokeWidth="1"/>
        <path
          id="path_221"
          d="M 1769.5 1960 L 1767.5 1963 L 1769.5 1960 Z"
          fill="currentColor"
          fillOpacity="0.8862745"
          stroke="currentColor"
          strokeOpacity="0.8862745"
          strokeWidth="1"/>
        <path
          id="path_222"
          d="M 1036.5 1965 L 1038.5 1968 L 1036.5 1965 Z"
          fill="currentColor"
          fillOpacity="0.8862745"
          stroke="currentColor"
          strokeOpacity="0.8862745"
          strokeWidth="1"/>
        <path
          id="path_223"
          d="M 1763.5 1967 L 1761.5 1970 L 1763.5 1967 Z"
          fill="currentColor"
          fillOpacity="0.8862745"
          stroke="currentColor"
          strokeOpacity="0.8862745"
          strokeWidth="1"/>
        <path
          id="path_224"
          d="M 1042.5 1972 L 1045.5 1976 L 1042.5 1972 Z"
          fill="currentColor"
          fillOpacity="0.8862745"
          stroke="currentColor"
          strokeOpacity="0.8862745"
          strokeWidth="1"/>
        <path
          id="path_225"
          d="M 1757.5 1974 L 1753.5 1979 L 1757.5 1974 Z"
          fill="currentColor"
          fillOpacity="0.8862745"
          stroke="currentColor"
          strokeOpacity="0.8862745"
          strokeWidth="1"/>
        <path
          id="path_226"
          d="M 1052.5 1983 L 1073.5 2005 L 1052.5 1983 Z"
          fill="currentColor"
          fillOpacity="0.8862745"
          stroke="currentColor"
          strokeOpacity="0.8862745"
          strokeWidth="1"/>
        <path
          id="path_227"
          d="M 1744.5 1988 L 1733.5 2000 L 1744.5 1988 Z"
          fill="currentColor"
          fillOpacity="0.8862745"
          stroke="currentColor"
          strokeOpacity="0.8862745"
          strokeWidth="1"/>
        <path
          id="path_228"
          d="M 1724.5 2007 L 1720.5 2012 L 1724.5 2007 Z"
          fill="currentColor"
          fillOpacity="0.8862745"
          stroke="currentColor"
          strokeOpacity="0.8862745"
          strokeWidth="1"/>
        <path
          id="path_229"
          d="M 1080.5 2010 L 1083.5 2014 L 1080.5 2010 Z"
          fill="currentColor"
          fillOpacity="0.8862745"
          stroke="currentColor"
          strokeOpacity="0.8862745"
          strokeWidth="1"/>
        <path
          id="path_230"
          d="M 1714.5 2016 L 1712.5 2019 L 1714.5 2016 Z"
          fill="currentColor"
          fillOpacity="0.8862745"
          stroke="currentColor"
          strokeOpacity="0.8862745"
          strokeWidth="1"/>
        <path
          id="path_231"
          d="M 1088.5 2017 L 1090.5 2020 L 1088.5 2017 Z"
          fill="currentColor"
          fillOpacity="0.8862745"
          stroke="currentColor"
          strokeOpacity="0.8862745"
          strokeWidth="1"/>
        <path
          id="path_232"
          d="M 1707.5 2022 L 1706.5 2024 L 1707.5 2022 Z"
          fill="currentColor"
          fillOpacity="0.8862745"
          stroke="currentColor"
          strokeOpacity="0.8862745"
          strokeWidth="1"/>
        <path
          id="path_233"
          d="M 1095.5 2023 L 1096.5 2025 L 1095.5 2023 Z"
          fill="currentColor"
          fillOpacity="0.8862745"
          stroke="currentColor"
          strokeOpacity="0.8862745"
          strokeWidth="1"/>
        <path
          id="path_234"
          d="M 1702.5 2026 L 1701.5 2028 L 1702.5 2026 Z"
          fill="currentColor"
          fillOpacity="0.8862745"
          stroke="currentColor"
          strokeOpacity="0.8862745"
          strokeWidth="1"/>
        <path
          id="path_235"
          d="M 1100.5 2027 L 1101.5 2029 L 1100.5 2027 Z"
          fill="currentColor"
          fillOpacity="0.8862745"
          stroke="currentColor"
          strokeOpacity="0.8862745"
          strokeWidth="1"/>
        <path
          id="path_236"
          d="M 1697.5 2030 L 1696.5 2032 L 1697.5 2030 Z"
          fill="currentColor"
          fillOpacity="0.8862745"
          stroke="currentColor"
          strokeOpacity="0.8862745"
          strokeWidth="1"/>
        <path
          id="path_237"
          d="M 1105.5 2031 L 1106.5 2033 L 1105.5 2031 Z"
          fill="currentColor"
          fillOpacity="0.8862745"
          stroke="currentColor"
          strokeOpacity="0.8862745"
          strokeWidth="1"/>
        <path
          id="path_238"
          d="M 1674.5 2047 L 1673.5 2049 L 1674.5 2047 Z"
          fill="currentColor"
          fillOpacity="0.8862745"
          stroke="currentColor"
          strokeOpacity="0.8862745"
          strokeWidth="1"/>
        <path
          id="path_239"
          d="M 960.5 0 L 1008.5 1 L 1009.5 2 L 1021.5 2 L 1022.5 3 L 1030.5 3 L 1031.5 4 L 1038.5 4 L 1039.5 5 L 1046.5 5 L 1047.5 6 L 1064.5 8 Q 1118.4 18.1 1163.5 37 Q 1268.3 81.7 1339 160.5 Q 1393.5 220 1428 299.5 L 1444 342.5 L 1455 382.5 L 1463 424.5 L 1465 448.5 L 1466 449.5 L 1467 474 L 1474.5 475 L 1496.5 482 L 1534.5 500 Q 1570.1 520.9 1597 550.5 Q 1645.1 601.4 1663 682.5 L 1665 701.5 L 1666 702.5 L 1666 711.5 L 1667 712.5 L 1667 934 L 2128 1167 L 2132 1179.5 L 2134 1190.5 L 2134 1209.5 L 2129 1229.5 Q 2123 1244 2112.5 1254 L 2096.5 1264 L 2082.5 1267 L 1867 1267 L 1867 1718.5 L 1866 1719.5 L 1866 1731.5 L 1865 1732.5 L 1865 1740.5 L 1864 1741.5 L 1862 1761.5 L 1853 1801.5 L 1842 1835.5 Q 1829.5 1868.5 1813 1897.5 Q 1777 1960 1725.5 2007 Q 1657.6 2070.6 1561.5 2106 L 1506.5 2122 L 1468.5 2129 L 1443.5 2131 L 1442.5 2132 L 1429.5 2132 L 1428.5 2133 L 1373.5 2133 L 1372.5 2132 L 1359.5 2132 L 1358.5 2131 L 1349.5 2131 L 1348.5 2130 L 1326.5 2128 L 1275.5 2117 Q 1231.9 2105.1 1194.5 2087 Q 1107.3 2044.7 1046 1976.5 Q 1005.5 1932 977 1875.5 Q 961.7 1844.8 951 1809.5 L 943 1778.5 L 938 1750.5 L 936 1723.5 L 935 1722.5 L 935 1702.5 L 934 1701.5 L 934 1267 L 719.5 1267 L 708.5 1265 L 697.5 1260 L 683 1247.5 Q 672.1 1235.4 667 1217.5 L 665 1208.5 L 665 1190.5 Q 667.4 1175.4 675.5 1166 L 1128 934 L 1128 707.5 L 1129 706.5 L 1130 689.5 L 1134 667.5 Q 1156.1 581.1 1214.5 531 Q 1234.8 512.8 1259.5 499 L 1294.5 483 L 1316.5 476 L 1328 474 L 1326 444.5 L 1325 443.5 L 1325 437.5 L 1321 414.5 Q 1311.9 374.1 1296 340.5 Q 1263.5 273 1210.5 226 Q 1159.4 179.1 1087.5 153 L 1061.5 145 L 1023.5 137 L 1000.5 135 L 999.5 134 L 985.5 134 L 984.5 133 L 950.5 133 L 949.5 134 L 935.5 134 L 934.5 135 L 917.5 136 L 884.5 142 Q 846.5 151 814.5 166 Q 748.4 197.4 702 248.5 Q 658.5 295.5 632 359.5 L 454 851.5 L 454 855.5 L 461 881.5 L 466 909.5 L 466 918.5 L 467 919.5 L 467 951.5 L 466 952.5 L 465 970.5 L 460 996.5 L 445 1040.5 Q 420.9 1093.4 380.5 1130 Q 345.6 1162.6 297.5 1182 L 270.5 1191 L 248.5 1196 L 228.5 1198 L 227.5 1199 L 200 1200 L 200 1234.5 L 199 1235.5 L 198 1246.5 L 193 1262.5 Q 181.6 1290.6 159.5 1308 Q 138.9 1325.9 106.5 1332 Q 101 1330.5 99.5 1333 L 1 1333 L 1 534.5 L 1.5 534 L 107.5 534 Q 157.2 542.3 183 574.5 Q 198.3 591.7 205 617.5 L 206 628.5 L 207 629.5 L 207 667 L 223.5 667 L 224.5 668 L 243.5 669 L 280.5 677 L 315.5 690 Q 343.9 703.4 368 720 L 503 341.5 L 507 327.5 L 523 287.5 Q 564.8 197.8 633.5 135 Q 699.3 73.3 789.5 36 L 835.5 20 L 875.5 10 L 903.5 5 L 918.5 4 L 919.5 3 L 939.5 2 L 940.5 1 L 959.5 1 L 960.5 0 Z M 1134 1267 L 1134 1711 L 1135 1712 L 1135 1722 L 1142 1760 L 1154 1795 Q 1172 1836 1200 1867 Q 1235 1905 1285 1929 Q 1308 1940 1337 1947 L 1365 1952 L 1387 1953 L 1388 1954 L 1415 1954 L 1416 1953 L 1429 1953 L 1430 1952 L 1446 1951 L 1479 1944 L 1498 1938 Q 1546 1920 1582 1889 Q 1622 1855 1645 1804 Q 1656 1780 1662 1753 L 1666 1730 L 1667 1708 L 1668 1707 L 1668 1268 L 1668 1267 L 1534 1267 L 1534 1664 L 1533 1665 L 1532 1679 L 1525 1703 Q 1515 1725 1500 1743 Q 1481 1764 1454 1776 L 1434 1783 L 1418 1786 L 1408 1786 L 1407 1787 L 1396 1787 L 1395 1786 L 1378 1785 L 1356 1779 Q 1331 1770 1314 1754 Q 1297 1739 1285 1720 L 1273 1692 L 1268 1667 L 1268 1267 L 1134 1267 Z"
          fill="currentColor"
          stroke="currentColor"
          strokeWidth="1"/>
        <path
          id="path_240"
          d="M 944.5 0 L 952 0.5 L 944.5 1 L 944.5 0 Z"
          fill="currentColor"
          fillOpacity="0.4588235"
          stroke="currentColor"
          strokeOpacity="0.4588235"
          strokeWidth="1"/>
        <path
          id="path_241"
          d="M 997.5 0 L 1006 0.5 L 997.5 1 L 997.5 0 Z"
          fill="currentColor"
          fillOpacity="0.4588235"
          stroke="currentColor"
          strokeOpacity="0.4588235"
          strokeWidth="1"/>
        <path
          id="path_242"
          d="M 931.5 1 L 936 1.5 L 931.5 2 L 931.5 1 Z"
          fill="currentColor"
          fillOpacity="0.4588235"
          stroke="currentColor"
          strokeOpacity="0.4588235"
          strokeWidth="1"/>
        <path
          id="path_243"
          d="M 1013.5 1 L 1019 1.5 L 1013.5 2 L 1013.5 1 Z"
          fill="currentColor"
          fillOpacity="0.4588235"
          stroke="currentColor"
          strokeOpacity="0.4588235"
          strokeWidth="1"/>
        <path
          id="path_244"
          d="M 921.5 2 L 925 2.5 L 921.5 3 L 921.5 2 Z"
          fill="currentColor"
          fillOpacity="0.4588235"
          stroke="currentColor"
          strokeOpacity="0.4588235"
          strokeWidth="1"/>
        <path
          id="path_245"
          d="M 1025.5 2 L 1029 2.5 L 1025.5 3 L 1025.5 2 Z"
          fill="currentColor"
          fillOpacity="0.4588235"
          stroke="currentColor"
          strokeOpacity="0.4588235"
          strokeWidth="1"/>
        <path
          id="path_246"
          d="M 912.5 3 L 916 3.5 L 912.5 4 L 912.5 3 Z"
          fill="currentColor"
          fillOpacity="0.4588235"
          stroke="currentColor"
          strokeOpacity="0.4588235"
          strokeWidth="1"/>
        <path
          id="path_247"
          d="M 1034.5 3 L 1038 3.5 L 1034.5 4 L 1034.5 3 Z"
          fill="currentColor"
          fillOpacity="0.4588235"
          stroke="currentColor"
          strokeOpacity="0.4588235"
          strokeWidth="1"/>
        <path
          id="path_248"
          d="M 905.5 4 L 908 4.5 L 905.5 5 L 905.5 4 Z"
          fill="currentColor"
          fillOpacity="0.4588235"
          stroke="currentColor"
          strokeOpacity="0.4588235"
          strokeWidth="1"/>
        <path
          id="path_249"
          d="M 1042.5 4 L 1045 4.5 L 1042.5 5 L 1042.5 4 Z"
          fill="currentColor"
          fillOpacity="0.4588235"
          stroke="currentColor"
          strokeOpacity="0.4588235"
          strokeWidth="1"/>
        <path
          id="path_250"
          d="M 1049.5 5 L 1052 5.5 L 1049.5 6 L 1049.5 5 Z"
          fill="currentColor"
          fillOpacity="0.4588235"
          stroke="currentColor"
          strokeOpacity="0.4588235"
          strokeWidth="1"/>
        <path
          id="path_251"
          d="M 892.5 6 L 895 6.5 L 892.5 7 L 892.5 6 Z"
          fill="currentColor"
          fillOpacity="0.4588235"
          stroke="currentColor"
          strokeOpacity="0.4588235"
          strokeWidth="1"/>
        <path
          id="path_252"
          d="M 1055.5 6 L 1058 6.5 L 1055.5 7 L 1055.5 6 Z"
          fill="currentColor"
          fillOpacity="0.4588235"
          stroke="currentColor"
          strokeOpacity="0.4588235"
          strokeWidth="1"/>
        <path
          id="path_253"
          d="M 1061.5 7 L 1064 7.5 L 1061.5 8 L 1061.5 7 Z"
          fill="currentColor"
          fillOpacity="0.4588235"
          stroke="currentColor"
          strokeOpacity="0.4588235"
          strokeWidth="1"/>
        <path
          id="path_254"
          d="M 881.5 8 L 884 8.5 L 881.5 9 L 881.5 8 Z"
          fill="currentColor"
          fillOpacity="0.4588235"
          stroke="currentColor"
          strokeOpacity="0.4588235"
          strokeWidth="1"/>
        <path
          id="path_255"
          d="M 712.5 74 L 711.5 76 L 712.5 74 Z"
          fill="currentColor"
          fillOpacity="0.4588235"
          stroke="currentColor"
          strokeOpacity="0.4588235"
          strokeWidth="1"/>
        <path
          id="path_256"
          d="M 1238.5 75 L 1239.5 77 L 1238.5 75 Z"
          fill="currentColor"
          fillOpacity="0.4588235"
          stroke="currentColor"
          strokeOpacity="0.4588235"
          strokeWidth="1"/>
        <path
          id="path_257"
          d="M 701.5 81 L 700.5 83 L 701.5 81 Z"
          fill="currentColor"
          fillOpacity="0.4588235"
          stroke="currentColor"
          strokeOpacity="0.4588235"
          strokeWidth="1"/>
        <path
          id="path_258"
          d="M 698.5 83 L 697.5 85 L 698.5 83 Z"
          fill="currentColor"
          fillOpacity="0.4588235"
          stroke="currentColor"
          strokeOpacity="0.4588235"
          strokeWidth="1"/>
        <path
          id="path_259"
          d="M 695.5 85 L 694.5 87 L 695.5 85 Z"
          fill="currentColor"
          fillOpacity="0.4588235"
          stroke="currentColor"
          strokeOpacity="0.4588235"
          strokeWidth="1"/>
        <path
          id="path_260"
          d="M 692.5 87 L 691.5 89 L 692.5 87 Z"
          fill="currentColor"
          fillOpacity="0.4588235"
          stroke="currentColor"
          strokeOpacity="0.4588235"
          strokeWidth="1"/>
        <path
          id="path_261"
          d="M 1256.5 87 L 1257.5 89 L 1256.5 87 Z"
          fill="currentColor"
          fillOpacity="0.4588235"
          stroke="currentColor"
          strokeOpacity="0.4588235"
          strokeWidth="1"/>
        <path
          id="path_262"
          d="M 1263.5 92 L 1264.5 94 L 1263.5 92 Z"
          fill="currentColor"
          fillOpacity="0.4588235"
          stroke="currentColor"
          strokeOpacity="0.4588235"
          strokeWidth="1"/>
        <path
          id="path_263"
          d="M 682.5 94 L 681.5 96 L 682.5 94 Z"
          fill="currentColor"
          fillOpacity="0.4588235"
          stroke="currentColor"
          strokeOpacity="0.4588235"
          strokeWidth="1"/>
        <path
          id="path_264"
          d="M 1275.5 101 L 1276.5 103 L 1275.5 101 Z"
          fill="currentColor"
          fillOpacity="0.4588235"
          stroke="currentColor"
          strokeOpacity="0.4588235"
          strokeWidth="1"/>
        <path
          id="path_265"
          d="M 666.5 106 L 665.5 108 L 666.5 106 Z"
          fill="currentColor"
          fillOpacity="0.4588235"
          stroke="currentColor"
          strokeOpacity="0.4588235"
          strokeWidth="1"/>
        <path
          id="path_266"
          d="M 661.5 110 L 660.5 112 L 661.5 110 Z"
          fill="currentColor"
          fillOpacity="0.4588235"
          stroke="currentColor"
          strokeOpacity="0.4588235"
          strokeWidth="1"/>
        <path
          id="path_267"
          d="M 1290.5 113 L 1291.5 115 L 1290.5 113 Z"
          fill="currentColor"
          fillOpacity="0.4588235"
          stroke="currentColor"
          strokeOpacity="0.4588235"
          strokeWidth="1"/>
        <path
          id="path_268"
          d="M 656.5 114 L 655.5 116 L 656.5 114 Z"
          fill="currentColor"
          fillOpacity="0.4588235"
          stroke="currentColor"
          strokeOpacity="0.4588235"
          strokeWidth="1"/>
        <path
          id="path_269"
          d="M 650.5 119 L 649.5 121 L 650.5 119 Z"
          fill="currentColor"
          fillOpacity="0.4588235"
          stroke="currentColor"
          strokeOpacity="0.4588235"
          strokeWidth="1"/>
        <path
          id="path_270"
          d="M 1297.5 119 L 1298.5 121 L 1297.5 119 Z"
          fill="currentColor"
          fillOpacity="0.4588235"
          stroke="currentColor"
          strokeOpacity="0.4588235"
          strokeWidth="1"/>
        <path
          id="path_271"
          d="M 643.5 125 L 641.5 128 L 643.5 125 Z"
          fill="currentColor"
          fillOpacity="0.4588235"
          stroke="currentColor"
          strokeOpacity="0.4588235"
          strokeWidth="1"/>
        <path
          id="path_272"
          d="M 1306.5 127 L 1308.5 130 L 1306.5 127 Z"
          fill="currentColor"
          fillOpacity="0.4588235"
          stroke="currentColor"
          strokeOpacity="0.4588235"
          strokeWidth="1"/>
        <path
          id="path_273"
          d="M 957.5 133 L 977 133.5 L 957.5 134 L 957.5 133 Z"
          fill="currentColor"
          fillOpacity="0.4588235"
          stroke="currentColor"
          strokeOpacity="0.4588235"
          strokeWidth="1"/>
        <path
          id="path_274"
          d="M 939.5 134 L 945 134.5 L 939.5 135 L 939.5 134 Z"
          fill="currentColor"
          fillOpacity="0.4588235"
          stroke="currentColor"
          strokeOpacity="0.4588235"
          strokeWidth="1"/>
        <path
          id="path_275"
          d="M 989.5 134 L 996 134.5 L 989.5 135 L 989.5 134 Z"
          fill="currentColor"
          fillOpacity="0.4588235"
          stroke="currentColor"
          strokeOpacity="0.4588235"
          strokeWidth="1"/>
        <path
          id="path_276"
          d="M 632.5 135 L 629.5 139 L 632.5 135 Z"
          fill="currentColor"
          fillOpacity="0.4588235"
          stroke="currentColor"
          strokeOpacity="0.4588235"
          strokeWidth="1"/>
        <path
          id="path_277"
          d="M 928.5 135 L 932 135.5 L 928.5 136 L 928.5 135 Z"
          fill="currentColor"
          fillOpacity="0.4588235"
          stroke="currentColor"
          strokeOpacity="0.4588235"
          strokeWidth="1"/>
        <path
          id="path_278"
          d="M 1002.5 135 L 1007 135.5 L 1002.5 136 L 1002.5 135 Z"
          fill="currentColor"
          fillOpacity="0.4588235"
          stroke="currentColor"
          strokeOpacity="0.4588235"
          strokeWidth="1"/>
        <path
          id="path_279"
          d="M 919.5 136 L 923 136.5 L 919.5 137 L 919.5 136 Z"
          fill="currentColor"
          fillOpacity="0.4588235"
          stroke="currentColor"
          strokeOpacity="0.4588235"
          strokeWidth="1"/>
        <path
          id="path_280"
          d="M 1012.5 136 L 1015 136.5 L 1012.5 137 L 1012.5 136 Z"
          fill="currentColor"
          fillOpacity="0.4588235"
          stroke="currentColor"
          strokeOpacity="0.4588235"
          strokeWidth="1"/>
        <path
          id="path_281"
          d="M 912.5 137 L 915 137.5 L 912.5 138 L 912.5 137 Z"
          fill="currentColor"
          fillOpacity="0.4588235"
          stroke="currentColor"
          strokeOpacity="0.4588235"
          strokeWidth="1"/>
        <path
          id="path_282"
          d="M 1019.5 137 L 1022 137.5 L 1019.5 138 L 1019.5 137 Z"
          fill="currentColor"
          fillOpacity="0.4588235"
          stroke="currentColor"
          strokeOpacity="0.4588235"
          strokeWidth="1"/>
        <path
          id="path_283"
          d="M 906.5 138 L 909 138.5 L 906.5 139 L 906.5 138 Z"
          fill="currentColor"
          fillOpacity="0.4588235"
          stroke="currentColor"
          strokeOpacity="0.4588235"
          strokeWidth="1"/>
        <path
          id="path_284"
          d="M 900.5 139 L 903 139.5 L 900.5 140 L 900.5 139 Z"
          fill="currentColor"
          fillOpacity="0.4588235"
          stroke="currentColor"
          strokeOpacity="0.4588235"
          strokeWidth="1"/>
        <path
          id="path_285"
          d="M 611.5 156 L 607.5 161 L 611.5 156 Z"
          fill="currentColor"
          fillOpacity="0.4588235"
          stroke="currentColor"
          strokeOpacity="0.4588235"
          strokeWidth="1"/>
        <path
          id="path_286"
          d="M 1336.5 157 L 1338.5 160 L 1336.5 157 Z"
          fill="currentColor"
          fillOpacity="0.4588235"
          stroke="currentColor"
          strokeOpacity="0.4588235"
          strokeWidth="1"/>
        <path
          id="path_287"
          d="M 1345.5 167 L 1346.5 169 L 1345.5 167 Z"
          fill="currentColor"
          fillOpacity="0.4588235"
          stroke="currentColor"
          strokeOpacity="0.4588235"
          strokeWidth="1"/>
        <path
          id="path_288"
          d="M 599.5 169 L 598.5 171 L 599.5 169 Z"
          fill="currentColor"
          fillOpacity="0.4588235"
          stroke="currentColor"
          strokeOpacity="0.4588235"
          strokeWidth="1"/>
        <path
          id="path_289"
          d="M 1351.5 174 L 1352.5 176 L 1351.5 174 Z"
          fill="currentColor"
          fillOpacity="0.4588235"
          stroke="currentColor"
          strokeOpacity="0.4588235"
          strokeWidth="1"/>
        <path
          id="path_290"
          d="M 593.5 176 L 592.5 178 L 593.5 176 Z"
          fill="currentColor"
          fillOpacity="0.4588235"
          stroke="currentColor"
          strokeOpacity="0.4588235"
          strokeWidth="1"/>
        <path
          id="path_291"
          d="M 588.5 182 L 587.5 184 L 588.5 182 Z"
          fill="currentColor"
          fillOpacity="0.4588235"
          stroke="currentColor"
          strokeOpacity="0.4588235"
          strokeWidth="1"/>
        <path
          id="path_292"
          d="M 1363.5 189 L 1364.5 191 L 1363.5 189 Z"
          fill="currentColor"
          fillOpacity="0.4588235"
          stroke="currentColor"
          strokeOpacity="0.4588235"
          strokeWidth="1"/>
        <path
          id="path_293"
          d="M 580.5 192 L 579.5 194 L 580.5 192 Z"
          fill="currentColor"
          fillOpacity="0.4588235"
          stroke="currentColor"
          strokeOpacity="0.4588235"
          strokeWidth="1"/>
        <path
          id="path_294"
          d="M 761.5 197 L 760.5 199 L 761.5 197 Z"
          fill="currentColor"
          fillOpacity="0.4588235"
          stroke="currentColor"
          strokeOpacity="0.4588235"
          strokeWidth="1"/>
        <path
          id="path_295"
          d="M 1174.5 198 L 1175.5 200 L 1174.5 198 Z"
          fill="currentColor"
          fillOpacity="0.4588235"
          stroke="currentColor"
          strokeOpacity="0.4588235"
          strokeWidth="1"/>
        <path
          id="path_296"
          d="M 1372.5 201 L 1373.5 203 L 1372.5 201 Z"
          fill="currentColor"
          fillOpacity="0.4588235"
          stroke="currentColor"
          strokeOpacity="0.4588235"
          strokeWidth="1"/>
        <path
          id="path_297"
          d="M 754.5 202 L 753.5 204 L 754.5 202 Z"
          fill="currentColor"
          fillOpacity="0.4588235"
          stroke="currentColor"
          strokeOpacity="0.4588235"
          strokeWidth="1"/>
        <path
          id="path_298"
          d="M 1181.5 203 L 1182.5 205 L 1181.5 203 Z"
          fill="currentColor"
          fillOpacity="0.4588235"
          stroke="currentColor"
          strokeOpacity="0.4588235"
          strokeWidth="1"/>
        <path
          id="path_299"
          d="M 750.5 205 L 749.5 207 L 750.5 205 Z"
          fill="currentColor"
          fillOpacity="0.4588235"
          stroke="currentColor"
          strokeOpacity="0.4588235"
          strokeWidth="1"/>
        <path
          id="path_300"
          d="M 1185.5 206 L 1186.5 208 L 1185.5 206 Z"
          fill="currentColor"
          fillOpacity="0.4588235"
          stroke="currentColor"
          strokeOpacity="0.4588235"
          strokeWidth="1"/>
        <path
          id="path_301"
          d="M 568.5 208 L 567.5 210 L 568.5 208 Z"
          fill="currentColor"
          fillOpacity="0.4588235"
          stroke="currentColor"
          strokeOpacity="0.4588235"
          strokeWidth="1"/>
        <path
          id="path_302"
          d="M 746.5 208 L 745.5 210 L 746.5 208 Z"
          fill="currentColor"
          fillOpacity="0.4588235"
          stroke="currentColor"
          strokeOpacity="0.4588235"
          strokeWidth="1"/>
        <path
          id="path_303"
          d="M 1377.5 208 L 1378.5 210 L 1377.5 208 Z"
          fill="currentColor"
          fillOpacity="0.4588235"
          stroke="currentColor"
          strokeOpacity="0.4588235"
          strokeWidth="1"/>
        <path
          id="path_304"
          d="M 1189.5 209 L 1190.5 211 L 1189.5 209 Z"
          fill="currentColor"
          fillOpacity="0.4588235"
          stroke="currentColor"
          strokeOpacity="0.4588235"
          strokeWidth="1"/>
        <path
          id="path_305"
          d="M 741.5 212 L 740.5 214 L 741.5 212 Z"
          fill="currentColor"
          fillOpacity="0.4588235"
          stroke="currentColor"
          strokeOpacity="0.4588235"
          strokeWidth="1"/>
        <path
          id="path_306"
          d="M 1194.5 213 L 1195.5 215 L 1194.5 213 Z"
          fill="currentColor"
          fillOpacity="0.4588235"
          stroke="currentColor"
          strokeOpacity="0.4588235"
          strokeWidth="1"/>
        <path
          id="path_307"
          d="M 735.5 217 L 734.5 219 L 735.5 217 Z"
          fill="currentColor"
          fillOpacity="0.4588235"
          stroke="currentColor"
          strokeOpacity="0.4588235"
          strokeWidth="1"/>
        <path
          id="path_308"
          d="M 1200.5 218 L 1201.5 220 L 1200.5 218 Z"
          fill="currentColor"
          fillOpacity="0.4588235"
          stroke="currentColor"
          strokeOpacity="0.4588235"
          strokeWidth="1"/>
        <path
          id="path_309"
          d="M 727.5 224 L 725.5 227 L 727.5 224 Z"
          fill="currentColor"
          fillOpacity="0.4588235"
          stroke="currentColor"
          strokeOpacity="0.4588235"
          strokeWidth="1"/>
        <path
          id="path_310"
          d="M 1207.5 224 L 1208.5 226 L 1207.5 224 Z"
          fill="currentColor"
          fillOpacity="0.4588235"
          stroke="currentColor"
          strokeOpacity="0.4588235"
          strokeWidth="1"/>
        <path
          id="path_311"
          d="M 552.5 232 L 551.5 234 L 552.5 232 Z"
          fill="currentColor"
          fillOpacity="0.4588235"
          stroke="currentColor"
          strokeOpacity="0.4588235"
          strokeWidth="1"/>
        <path
          id="path_312"
          d="M 1219.5 235 L 1228.5 245 L 1219.5 235 Z"
          fill="currentColor"
          fillOpacity="0.4588235"
          stroke="currentColor"
          strokeOpacity="0.4588235"
          strokeWidth="1"/>
        <path
          id="path_313"
          d="M 701.5 250 L 699.5 253 L 701.5 250 Z"
          fill="currentColor"
          fillOpacity="0.4588235"
          stroke="currentColor"
          strokeOpacity="0.4588235"
          strokeWidth="1"/>
        <path
          id="path_314"
          d="M 1238.5 255 L 1240.5 258 L 1238.5 255 Z"
          fill="currentColor"
          fillOpacity="0.4588235"
          stroke="currentColor"
          strokeOpacity="0.4588235"
          strokeWidth="1"/>
        <path
          id="path_315"
          d="M 694.5 258 L 693.5 260 L 694.5 258 Z"
          fill="currentColor"
          fillOpacity="0.4588235"
          stroke="currentColor"
          strokeOpacity="0.4588235"
          strokeWidth="1"/>
        <path
          id="path_316"
          d="M 1245.5 263 L 1246.5 265 L 1245.5 263 Z"
          fill="currentColor"
          fillOpacity="0.4588235"
          stroke="currentColor"
          strokeOpacity="0.4588235"
          strokeWidth="1"/>
        <path
          id="path_317"
          d="M 689.5 264 L 688.5 266 L 689.5 264 Z"
          fill="currentColor"
          fillOpacity="0.4588235"
          stroke="currentColor"
          strokeOpacity="0.4588235"
          strokeWidth="1"/>
        <path
          id="path_318"
          d="M 1249.5 268 L 1250.5 270 L 1249.5 268 Z"
          fill="currentColor"
          fillOpacity="0.4588235"
          stroke="currentColor"
          strokeOpacity="0.4588235"
          strokeWidth="1"/>
        <path
          id="path_319"
          d="M 685.5 269 L 684.5 271 L 685.5 269 Z"
          fill="currentColor"
          fillOpacity="0.4588235"
          stroke="currentColor"
          strokeOpacity="0.4588235"
          strokeWidth="1"/>
        <path
          id="path_320"
          d="M 1253.5 273 L 1254.5 275 L 1253.5 273 Z"
          fill="currentColor"
          fillOpacity="0.4588235"
          stroke="currentColor"
          strokeOpacity="0.4588235"
          strokeWidth="1"/>
        <path
          id="path_321"
          d="M 1262.5 285 L 1263.5 287 L 1262.5 285 Z"
          fill="currentColor"
          fillOpacity="0.4588235"
          stroke="currentColor"
          strokeOpacity="0.4588235"
          strokeWidth="1"/>
        <path
          id="path_322"
          d="M 671.5 288 L 670.5 290 L 671.5 288 Z"
          fill="currentColor"
          fillOpacity="0.4588235"
          stroke="currentColor"
          strokeOpacity="0.4588235"
          strokeWidth="1"/>
        <path
          id="path_323"
          d="M 665.5 297 L 664.5 299 L 665.5 297 Z"
          fill="currentColor"
          fillOpacity="0.4588235"
          stroke="currentColor"
          strokeOpacity="0.4588235"
          strokeWidth="1"/>
        <path
          id="path_324"
          d="M 1274.5 303 L 1275.5 305 L 1274.5 303 Z"
          fill="currentColor"
          fillOpacity="0.4588235"
          stroke="currentColor"
          strokeOpacity="0.4588235"
          strokeWidth="1"/>
        <path
          id="path_325"
          d="M 1461.5 413 L 1462 415.5 L 1461 415.5 L 1461.5 413 Z"
          fill="currentColor"
          fillOpacity="0.4588235"
          stroke="currentColor"
          strokeOpacity="0.4588235"
          strokeWidth="1"/>
        <path
          id="path_326"
          d="M 1322.5 426 L 1323 428.5 L 1322 428.5 L 1322.5 426 Z"
          fill="currentColor"
          fillOpacity="0.4588235"
          stroke="currentColor"
          strokeOpacity="0.4588235"
          strokeWidth="1"/>
        <path
          id="path_327"
          d="M 1463.5 426 L 1464 428.5 L 1463 428.5 L 1463.5 426 Z"
          fill="currentColor"
          fillOpacity="0.4588235"
          stroke="currentColor"
          strokeOpacity="0.4588235"
          strokeWidth="1"/>
        <path
          id="path_328"
          d="M 1323.5 432 L 1324 434.5 L 1323 434.5 L 1323.5 432 Z"
          fill="currentColor"
          fillOpacity="0.4588235"
          stroke="currentColor"
          strokeOpacity="0.4588235"
          strokeWidth="1"/>
        <path
          id="path_329"
          d="M 1464.5 434 L 1465 436.5 L 1464 436.5 L 1464.5 434 Z"
          fill="currentColor"
          fillOpacity="0.4588235"
          stroke="currentColor"
          strokeOpacity="0.4588235"
          strokeWidth="1"/>
        <path
          id="path_330"
          d="M 1324.5 439 L 1325 441.5 L 1324 441.5 L 1324.5 439 Z"
          fill="currentColor"
          fillOpacity="0.4588235"
          stroke="currentColor"
          strokeOpacity="0.4588235"
          strokeWidth="1"/>
        <path
          id="path_331"
          d="M 1465.5 442 L 1466 445.5 L 1465 445.5 L 1465.5 442 Z"
          fill="currentColor"
          fillOpacity="0.4588235"
          stroke="currentColor"
          strokeOpacity="0.4588235"
          strokeWidth="1"/>
        <path
          id="path_332"
          d="M 1325.5 447 L 1326 450.5 L 1325 450.5 L 1325.5 447 Z"
          fill="currentColor"
          fillOpacity="0.4588235"
          stroke="currentColor"
          strokeOpacity="0.4588235"
          strokeWidth="1"/>
        <path
          id="path_333"
          d="M 1466.5 452 L 1467 456.5 L 1466 456.5 L 1466.5 452 Z"
          fill="currentColor"
          fillOpacity="0.4588235"
          stroke="currentColor"
          strokeOpacity="0.4588235"
          strokeWidth="1"/>
        <path
          id="path_334"
          d="M 1326.5 457 L 1327 462.5 L 1326 462.5 L 1326.5 457 Z"
          fill="currentColor"
          fillOpacity="0.4588235"
          stroke="currentColor"
          strokeOpacity="0.4588235"
          strokeWidth="1"/>
        <path
          id="path_335"
          d="M 1467.5 464 L 1468 471.5 L 1467 471.5 L 1467.5 464 Z"
          fill="currentColor"
          fillOpacity="0.4588235"
          stroke="currentColor"
          strokeOpacity="0.4588235"
          strokeWidth="1"/>
        <path
          id="path_336"
          d="M 1234.5 514 L 1233.5 516 L 1234.5 514 Z"
          fill="currentColor"
          fillOpacity="0.4588235"
          stroke="currentColor"
          strokeOpacity="0.4588235"
          strokeWidth="1"/>
        <path
          id="path_337"
          d="M 1557.5 514 L 1558.5 516 L 1557.5 514 Z"
          fill="currentColor"
          fillOpacity="0.4588235"
          stroke="currentColor"
          strokeOpacity="0.4588235"
          strokeWidth="1"/>
        <path
          id="path_338"
          d="M 1230.5 517 L 1229.5 519 L 1230.5 517 Z"
          fill="currentColor"
          fillOpacity="0.4588235"
          stroke="currentColor"
          strokeOpacity="0.4588235"
          strokeWidth="1"/>
        <path
          id="path_339"
          d="M 1561.5 517 L 1562.5 519 L 1561.5 517 Z"
          fill="currentColor"
          fillOpacity="0.4588235"
          stroke="currentColor"
          strokeOpacity="0.4588235"
          strokeWidth="1"/>
        <path
          id="path_340"
          d="M 1226.5 520 L 1225.5 522 L 1226.5 520 Z"
          fill="currentColor"
          fillOpacity="0.4588235"
          stroke="currentColor"
          strokeOpacity="0.4588235"
          strokeWidth="1"/>
        <path
          id="path_341"
          d="M 1566.5 521 L 1567.5 523 L 1566.5 521 Z"
          fill="currentColor"
          fillOpacity="0.4588235"
          stroke="currentColor"
          strokeOpacity="0.4588235"
          strokeWidth="1"/>
        <path
          id="path_342"
          d="M 1221.5 524 L 1220.5 526 L 1221.5 524 Z"
          fill="currentColor"
          fillOpacity="0.4588235"
          stroke="currentColor"
          strokeOpacity="0.4588235"
          strokeWidth="1"/>
        <path
          id="path_343"
          d="M 1571.5 525 L 1572.5 527 L 1571.5 525 Z"
          fill="currentColor"
          fillOpacity="0.4588235"
          stroke="currentColor"
          strokeOpacity="0.4588235"
          strokeWidth="1"/>
        <path
          id="path_344"
          d="M 1214.5 530 L 1212.5 533 L 1214.5 530 Z"
          fill="currentColor"
          fillOpacity="0.4588235"
          stroke="currentColor"
          strokeOpacity="0.4588235"
          strokeWidth="1"/>
        <path
          id="path_345"
          d="M 1579.5 532 L 1582.5 536 L 1579.5 532 Z"
          fill="currentColor"
          fillOpacity="0.4588235"
          stroke="currentColor"
          strokeOpacity="0.4588235"
          strokeWidth="1"/>
        <path
          id="path_346"
          d="M 0.5 533 L 1 1333 L 98 1333.5 L 0 1334 L 0.5 533 Z"
          fill="currentColor"
          fillOpacity="0.4588235"
          stroke="currentColor"
          strokeOpacity="0.4588235"
          strokeWidth="1"/>
        <path
          id="path_347"
          d="M 99.5 533 L 106 533.5 L 99.5 534 L 99.5 533 Z"
          fill="currentColor"
          fillOpacity="0.4588235"
          stroke="currentColor"
          strokeOpacity="0.4588235"
          strokeWidth="1"/>
        <path
          id="path_348"
          d="M 110.5 534 L 113 534.5 L 110.5 535 L 110.5 534 Z"
          fill="currentColor"
          fillOpacity="0.4588235"
          stroke="currentColor"
          strokeOpacity="0.4588235"
          strokeWidth="1"/>
        <path
          id="path_349"
          d="M 1594.5 547 L 1597.5 551 L 1594.5 547 Z"
          fill="currentColor"
          fillOpacity="0.4588235"
          stroke="currentColor"
          strokeOpacity="0.4588235"
          strokeWidth="1"/>
        <path
          id="path_350"
          d="M 1194.5 550 L 1192.5 553 L 1194.5 550 Z"
          fill="currentColor"
          fillOpacity="0.4588235"
          stroke="currentColor"
          strokeOpacity="0.4588235"
          strokeWidth="1"/>
        <path
          id="path_351"
          d="M 164.5 556 L 165.5 558 L 164.5 556 Z"
          fill="currentColor"
          fillOpacity="0.4588235"
          stroke="currentColor"
          strokeOpacity="0.4588235"
          strokeWidth="1"/>
        <path
          id="path_352"
          d="M 1603.5 557 L 1604.5 559 L 1603.5 557 Z"
          fill="currentColor"
          fillOpacity="0.4588235"
          stroke="currentColor"
          strokeOpacity="0.4588235"
          strokeWidth="1"/>
        <path
          id="path_353"
          d="M 1187.5 558 L 1186.5 560 L 1187.5 558 Z"
          fill="currentColor"
          fillOpacity="0.4588235"
          stroke="currentColor"
          strokeOpacity="0.4588235"
          strokeWidth="1"/>
        <path
          id="path_354"
          d="M 169.5 560 L 170.5 562 L 169.5 560 Z"
          fill="currentColor"
          fillOpacity="0.4588235"
          stroke="currentColor"
          strokeOpacity="0.4588235"
          strokeWidth="1"/>
        <path
          id="path_355"
          d="M 1607.5 562 L 1608.5 564 L 1607.5 562 Z"
          fill="currentColor"
          fillOpacity="0.4588235"
          stroke="currentColor"
          strokeOpacity="0.4588235"
          strokeWidth="1"/>
        <path
          id="path_356"
          d="M 1183.5 563 L 1182.5 565 L 1183.5 563 Z"
          fill="currentColor"
          fillOpacity="0.4588235"
          stroke="currentColor"
          strokeOpacity="0.4588235"
          strokeWidth="1"/>
        <path
          id="path_357"
          d="M 1180.5 567 L 1179.5 569 L 1180.5 567 Z"
          fill="currentColor"
          fillOpacity="0.4588235"
          stroke="currentColor"
          strokeOpacity="0.4588235"
          strokeWidth="1"/>
        <path
          id="path_358"
          d="M 1611.5 567 L 1612.5 569 L 1611.5 567 Z"
          fill="currentColor"
          fillOpacity="0.4588235"
          stroke="currentColor"
          strokeOpacity="0.4588235"
          strokeWidth="1"/>
        <path
          id="path_359"
          d="M 1177.5 571 L 1176.5 573 L 1177.5 571 Z"
          fill="currentColor"
          fillOpacity="0.4588235"
          stroke="currentColor"
          strokeOpacity="0.4588235"
          strokeWidth="1"/>
        <path
          id="path_360"
          d="M 1614.5 571 L 1615.5 573 L 1614.5 571 Z"
          fill="currentColor"
          fillOpacity="0.4588235"
          stroke="currentColor"
          strokeOpacity="0.4588235"
          strokeWidth="1"/>
        <path
          id="path_361"
          d="M 182.5 573 L 183.5 575 L 182.5 573 Z"
          fill="currentColor"
          fillOpacity="0.4588235"
          stroke="currentColor"
          strokeOpacity="0.4588235"
          strokeWidth="1"/>
        <path
          id="path_362"
          d="M 186.5 578 L 187.5 580 L 186.5 578 Z"
          fill="currentColor"
          fillOpacity="0.4588235"
          stroke="currentColor"
          strokeOpacity="0.4588235"
          strokeWidth="1"/>
        <path
          id="path_363"
          d="M 1619.5 578 L 1620.5 580 L 1619.5 578 Z"
          fill="currentColor"
          fillOpacity="0.4588235"
          stroke="currentColor"
          strokeOpacity="0.4588235"
          strokeWidth="1"/>
        <path
          id="path_364"
          d="M 1621.5 581 L 1622.5 583 L 1621.5 581 Z"
          fill="currentColor"
          fillOpacity="0.4588235"
          stroke="currentColor"
          strokeOpacity="0.4588235"
          strokeWidth="1"/>
        <path
          id="path_365"
          d="M 1623.5 584 L 1624.5 586 L 1623.5 584 Z"
          fill="currentColor"
          fillOpacity="0.4588235"
          stroke="currentColor"
          strokeOpacity="0.4588235"
          strokeWidth="1"/>
        <path
          id="path_366"
          d="M 207.5 631 L 208 666 L 219 666.5 L 208.5 667 L 207 665.5 L 207.5 631 Z"
          fill="currentColor"
          fillOpacity="0.4588235"
          stroke="currentColor"
          strokeOpacity="0.4588235"
          strokeWidth="1"/>
        <path
          id="path_367"
          d="M 228.5 667 L 233 667.5 L 228.5 668 L 228.5 667 Z"
          fill="currentColor"
          fillOpacity="0.4588235"
          stroke="currentColor"
          strokeOpacity="0.4588235"
          strokeWidth="1"/>
        <path
          id="path_368"
          d="M 238.5 668 L 242 668.5 L 238.5 669 L 238.5 668 Z"
          fill="currentColor"
          fillOpacity="0.4588235"
          stroke="currentColor"
          strokeOpacity="0.4588235"
          strokeWidth="1"/>
        <path
          id="path_369"
          d="M 246.5 669 L 249 669.5 L 246.5 670 L 246.5 669 Z"
          fill="currentColor"
          fillOpacity="0.4588235"
          stroke="currentColor"
          strokeOpacity="0.4588235"
          strokeWidth="1"/>
        <path
          id="path_370"
          d="M 1130.5 684 L 1131 686.5 L 1130 686.5 L 1130.5 684 Z"
          fill="currentColor"
          fillOpacity="0.4588235"
          stroke="currentColor"
          strokeOpacity="0.4588235"
          strokeWidth="1"/>
        <path
          id="path_371"
          d="M 1664.5 689 L 1665 691.5 L 1664 691.5 L 1664.5 689 Z"
          fill="currentColor"
          fillOpacity="0.4588235"
          stroke="currentColor"
          strokeOpacity="0.4588235"
          strokeWidth="1"/>
        <path
          id="path_372"
          d="M 1129.5 691 L 1130 693.5 L 1129 693.5 L 1129.5 691 Z"
          fill="currentColor"
          fillOpacity="0.4588235"
          stroke="currentColor"
          strokeOpacity="0.4588235"
          strokeWidth="1"/>
        <path
          id="path_373"
          d="M 1665.5 696 L 1666 698.5 L 1665 698.5 L 1665.5 696 Z"
          fill="currentColor"
          fillOpacity="0.4588235"
          stroke="currentColor"
          strokeOpacity="0.4588235"
          strokeWidth="1"/>
        <path
          id="path_374"
          d="M 1128.5 699 L 1129 702.5 L 1128 702.5 L 1128.5 699 Z"
          fill="currentColor"
          fillOpacity="0.4588235"
          stroke="currentColor"
          strokeOpacity="0.4588235"
          strokeWidth="1"/>
        <path
          id="path_375"
          d="M 1666.5 704 L 1667 708.5 L 1666 708.5 L 1666.5 704 Z"
          fill="currentColor"
          fillOpacity="0.4588235"
          stroke="currentColor"
          strokeOpacity="0.4588235"
          strokeWidth="1"/>
        <path
          id="path_376"
          d="M 355.5 711 L 356.5 713 L 355.5 711 Z"
          fill="currentColor"
          fillOpacity="0.4588235"
          stroke="currentColor"
          strokeOpacity="0.4588235"
          strokeWidth="1"/>
        <path
          id="path_377"
          d="M 1127.5 711 L 1128 932.5 L 1126 933.5 L 1127 932.5 L 1127.5 711 Z"
          fill="currentColor"
          fillOpacity="0.4588235"
          stroke="currentColor"
          strokeOpacity="0.4588235"
          strokeWidth="1"/>
        <path
          id="path_378"
          d="M 358.5 713 L 359.5 715 L 358.5 713 Z"
          fill="currentColor"
          fillOpacity="0.4588235"
          stroke="currentColor"
          strokeOpacity="0.4588235"
          strokeWidth="1"/>
        <path
          id="path_379"
          d="M 361.5 715 L 362.5 717 L 361.5 715 Z"
          fill="currentColor"
          fillOpacity="0.4588235"
          stroke="currentColor"
          strokeOpacity="0.4588235"
          strokeWidth="1"/>
        <path
          id="path_380"
          d="M 1667.5 716 L 1668 726.5 L 1667 726.5 L 1667.5 716 Z"
          fill="currentColor"
          fillOpacity="0.4588235"
          stroke="currentColor"
          strokeOpacity="0.4588235"
          strokeWidth="1"/>
        <path
          id="path_381"
          d="M 463.5 892 L 464 894.5 L 463 894.5 L 463.5 892 Z"
          fill="currentColor"
          fillOpacity="0.4588235"
          stroke="currentColor"
          strokeOpacity="0.4588235"
          strokeWidth="1"/>
        <path
          id="path_382"
          d="M 465.5 904 L 466 906.5 L 465 906.5 L 465.5 904 Z"
          fill="currentColor"
          fillOpacity="0.4588235"
          stroke="currentColor"
          strokeOpacity="0.4588235"
          strokeWidth="1"/>
        <path
          id="path_383"
          d="M 466.5 911 L 467 914.5 L 466 914.5 L 466.5 911 Z"
          fill="currentColor"
          fillOpacity="0.4588235"
          stroke="currentColor"
          strokeOpacity="0.4588235"
          strokeWidth="1"/>
        <path
          id="path_384"
          d="M 467.5 922 L 468 947.5 L 467 947.5 L 467.5 922 Z"
          fill="currentColor"
          fillOpacity="0.4588235"
          stroke="currentColor"
          strokeOpacity="0.4588235"
          strokeWidth="1"/>
        <path
          id="path_385"
          d="M 466.5 956 L 467 960.5 L 466 960.5 L 466.5 956 Z"
          fill="currentColor"
          fillOpacity="0.4588235"
          stroke="currentColor"
          strokeOpacity="0.4588235"
          strokeWidth="1"/>
        <path
          id="path_386"
          d="M 465.5 966 L 466 968.5 L 465 968.5 L 465.5 966 Z"
          fill="currentColor"
          fillOpacity="0.4588235"
          stroke="currentColor"
          strokeOpacity="0.4588235"
          strokeWidth="1"/>
        <path
          id="path_387"
          d="M 464.5 973 L 465 975.5 L 464 975.5 L 464.5 973 Z"
          fill="currentColor"
          fillOpacity="0.4588235"
          stroke="currentColor"
          strokeOpacity="0.4588235"
          strokeWidth="1"/>
        <path
          id="path_388"
          d="M 463.5 979 L 464 981.5 L 463 981.5 L 463.5 979 Z"
          fill="currentColor"
          fillOpacity="0.4588235"
          stroke="currentColor"
          strokeOpacity="0.4588235"
          strokeWidth="1"/>
        <path
          id="path_389"
          d="M 418.5 1087 L 417.5 1089 L 418.5 1087 Z"
          fill="currentColor"
          fillOpacity="0.4588235"
          stroke="currentColor"
          strokeOpacity="0.4588235"
          strokeWidth="1"/>
        <path
          id="path_390"
          d="M 409.5 1099 L 408.5 1101 L 409.5 1099 Z"
          fill="currentColor"
          fillOpacity="0.4588235"
          stroke="currentColor"
          strokeOpacity="0.4588235"
          strokeWidth="1"/>
        <path
          id="path_391"
          d="M 404.5 1105 L 403.5 1107 L 404.5 1105 Z"
          fill="currentColor"
          fillOpacity="0.4588235"
          stroke="currentColor"
          strokeOpacity="0.4588235"
          strokeWidth="1"/>
        <path
          id="path_392"
          d="M 397.5 1113 L 394.5 1117 L 397.5 1113 Z"
          fill="currentColor"
          fillOpacity="0.4588235"
          stroke="currentColor"
          strokeOpacity="0.4588235"
          strokeWidth="1"/>
        <path
          id="path_393"
          d="M 383.5 1127 L 380.5 1131 L 383.5 1127 Z"
          fill="currentColor"
          fillOpacity="0.4588235"
          stroke="currentColor"
          strokeOpacity="0.4588235"
          strokeWidth="1"/>
        <path
          id="path_394"
          d="M 373.5 1136 L 372.5 1138 L 373.5 1136 Z"
          fill="currentColor"
          fillOpacity="0.4588235"
          stroke="currentColor"
          strokeOpacity="0.4588235"
          strokeWidth="1"/>
        <path
          id="path_395"
          d="M 363.5 1144 L 362.5 1146 L 363.5 1144 Z"
          fill="currentColor"
          fillOpacity="0.4588235"
          stroke="currentColor"
          strokeOpacity="0.4588235"
          strokeWidth="1"/>
        <path
          id="path_396"
          d="M 355.5 1150 L 354.5 1152 L 355.5 1150 Z"
          fill="currentColor"
          fillOpacity="0.4588235"
          stroke="currentColor"
          strokeOpacity="0.4588235"
          strokeWidth="1"/>
        <path
          id="path_397"
          d="M 674.5 1166 L 673.5 1168 L 674.5 1166 Z"
          fill="currentColor"
          fillOpacity="0.4588235"
          stroke="currentColor"
          strokeOpacity="0.4588235"
          strokeWidth="1"/>
        <path
          id="path_398"
          d="M 664.5 1192 L 665 1206.5 L 664 1206.5 L 664.5 1192 Z"
          fill="currentColor"
          fillOpacity="0.4588235"
          stroke="currentColor"
          strokeOpacity="0.4588235"
          strokeWidth="1"/>
        <path
          id="path_399"
          d="M 2134.5 1192 L 2135 1207.5 L 2134 1207.5 L 2134.5 1192 Z"
          fill="currentColor"
          fillOpacity="0.4588235"
          stroke="currentColor"
          strokeOpacity="0.4588235"
          strokeWidth="1"/>
        <path
          id="path_400"
          d="M 231.5 1198 L 234 1198.5 L 231.5 1199 L 231.5 1198 Z"
          fill="currentColor"
          fillOpacity="0.4588235"
          stroke="currentColor"
          strokeOpacity="0.4588235"
          strokeWidth="1"/>
        <path
          id="path_401"
          d="M 220.5 1199 L 225 1199.5 L 220.5 1200 L 220.5 1199 Z"
          fill="currentColor"
          fillOpacity="0.4588235"
          stroke="currentColor"
          strokeOpacity="0.4588235"
          strokeWidth="1"/>
        <path
          id="path_402"
          d="M 201.5 1200 L 209 1200.5 L 201.5 1201 L 201.5 1200 Z"
          fill="currentColor"
          fillOpacity="0.4588235"
          stroke="currentColor"
          strokeOpacity="0.4588235"
          strokeWidth="1"/>
        <path
          id="path_403"
          d="M 2133.5 1212 L 2134 1214.5 L 2133 1214.5 L 2133.5 1212 Z"
          fill="currentColor"
          fillOpacity="0.4588235"
          stroke="currentColor"
          strokeOpacity="0.4588235"
          strokeWidth="1"/>
        <path
          id="path_404"
          d="M 200.5 1228 L 201 1232.5 L 200 1232.5 L 200.5 1228 Z"
          fill="currentColor"
          fillOpacity="0.4588235"
          stroke="currentColor"
          strokeOpacity="0.4588235"
          strokeWidth="1"/>
        <path
          id="path_405"
          d="M 678.5 1242 L 679.5 1244 L 678.5 1242 Z"
          fill="currentColor"
          fillOpacity="0.4588235"
          stroke="currentColor"
          strokeOpacity="0.4588235"
          strokeWidth="1"/>
        <path
          id="path_406"
          d="M 2120.5 1245 L 2119.5 1247 L 2120.5 1245 Z"
          fill="currentColor"
          fillOpacity="0.4588235"
          stroke="currentColor"
          strokeOpacity="0.4588235"
          strokeWidth="1"/>
        <path
          id="path_407"
          d="M 682.5 1247 L 684.5 1250 L 682.5 1247 Z"
          fill="currentColor"
          fillOpacity="0.4588235"
          stroke="currentColor"
          strokeOpacity="0.4588235"
          strokeWidth="1"/>
        <path
          id="path_408"
          d="M 2115.5 1251 L 2113.5 1254 L 2115.5 1251 Z"
          fill="currentColor"
          fillOpacity="0.4588235"
          stroke="currentColor"
          strokeOpacity="0.4588235"
          strokeWidth="1"/>
        <path
          id="path_409"
          d="M 687.5 1252 L 689.5 1255 L 687.5 1252 Z"
          fill="currentColor"
          fillOpacity="0.4588235"
          stroke="currentColor"
          strokeOpacity="0.4588235"
          strokeWidth="1"/>
        <path
          id="path_410"
          d="M 2108.5 1257 L 2107.5 1259 L 2108.5 1257 Z"
          fill="currentColor"
          fillOpacity="0.4588235"
          stroke="currentColor"
          strokeOpacity="0.4588235"
          strokeWidth="1"/>
        <path
          id="path_411"
          d="M 1134.5 1267 L 1135 1705.5 L 1134 1705.5 L 1134.5 1267 Z"
          fill="currentColor"
          fillOpacity="0.4588235"
          stroke="currentColor"
          strokeOpacity="0.4588235"
          strokeWidth="1"/>
        <path
          id="path_412"
          d="M 1267.5 1267 L 1268 1664.5 L 1267 1664.5 L 1267.5 1267 Z"
          fill="currentColor"
          fillOpacity="0.4588235"
          stroke="currentColor"
          strokeOpacity="0.4588235"
          strokeWidth="1"/>
        <path
          id="path_413"
          d="M 1534.5 1267 L 1535 1660.5 L 1534 1660.5 L 1534.5 1267 Z"
          fill="currentColor"
          fillOpacity="0.4588235"
          stroke="currentColor"
          strokeOpacity="0.4588235"
          strokeWidth="1"/>
        <path
          id="path_414"
          d="M 1667.5 1267 L 1668 1699.5 L 1667 1699.5 L 1667.5 1267 Z"
          fill="currentColor"
          fillOpacity="0.4588235"
          stroke="currentColor"
          strokeOpacity="0.4588235"
          strokeWidth="1"/>
        <path
          id="path_415"
          d="M 176.5 1291 L 175.5 1293 L 176.5 1291 Z"
          fill="currentColor"
          fillOpacity="0.4588235"
          stroke="currentColor"
          strokeOpacity="0.4588235"
          strokeWidth="1"/>
        <path
          id="path_416"
          d="M 160.5 1307 L 159.5 1309 L 160.5 1307 Z"
          fill="currentColor"
          fillOpacity="0.4588235"
          stroke="currentColor"
          strokeOpacity="0.4588235"
          strokeWidth="1"/>
        <path
          id="path_417"
          d="M 103.5 1332 L 106 1332.5 L 103.5 1333 L 103.5 1332 Z"
          fill="currentColor"
          fillOpacity="0.4588235"
          stroke="currentColor"
          strokeOpacity="0.4588235"
          strokeWidth="1"/>
        <path
          id="path_418"
          d="M 1533.5 1668 L 1534 1670.5 L 1533 1670.5 L 1533.5 1668 Z"
          fill="currentColor"
          fillOpacity="0.4588235"
          stroke="currentColor"
          strokeOpacity="0.4588235"
          strokeWidth="1"/>
        <path
          id="path_419"
          d="M 1268.5 1670 L 1269 1672.5 L 1268 1672.5 L 1268.5 1670 Z"
          fill="currentColor"
          fillOpacity="0.4588235"
          stroke="currentColor"
          strokeOpacity="0.4588235"
          strokeWidth="1"/>
        <path
          id="path_420"
          d="M 1532.5 1675 L 1533 1677.5 L 1532 1677.5 L 1532.5 1675 Z"
          fill="currentColor"
          fillOpacity="0.4588235"
          stroke="currentColor"
          strokeOpacity="0.4588235"
          strokeWidth="1"/>
        <path
          id="path_421"
          d="M 1867.5 1702 L 1868 1714.5 L 1867 1714.5 L 1867.5 1702 Z"
          fill="currentColor"
          fillOpacity="0.4588235"
          stroke="currentColor"
          strokeOpacity="0.4588235"
          strokeWidth="1"/>
        <path
          id="path_422"
          d="M 934.5 1711 L 935 1719.5 L 934 1719.5 L 934.5 1711 Z"
          fill="currentColor"
          fillOpacity="0.4588235"
          stroke="currentColor"
          strokeOpacity="0.4588235"
          strokeWidth="1"/>
        <path
          id="path_423"
          d="M 1666.5 1712 L 1667 1717.5 L 1666 1717.5 L 1666.5 1712 Z"
          fill="currentColor"
          fillOpacity="0.4588235"
          stroke="currentColor"
          strokeOpacity="0.4588235"
          strokeWidth="1"/>
        <path
          id="path_424"
          d="M 1135.5 1714 L 1136 1718.5 L 1135 1718.5 L 1135.5 1714 Z"
          fill="currentColor"
          fillOpacity="0.4588235"
          stroke="currentColor"
          strokeOpacity="0.4588235"
          strokeWidth="1"/>
        <path
          id="path_425"
          d="M 1665.5 1723 L 1666 1726.5 L 1665 1726.5 L 1665.5 1723 Z"
          fill="currentColor"
          fillOpacity="0.4588235"
          stroke="currentColor"
          strokeOpacity="0.4588235"
          strokeWidth="1"/>
        <path
          id="path_426"
          d="M 1866.5 1723 L 1867 1728.5 L 1866 1728.5 L 1866.5 1723 Z"
          fill="currentColor"
          fillOpacity="0.4588235"
          stroke="currentColor"
          strokeOpacity="0.4588235"
          strokeWidth="1"/>
        <path
          id="path_427"
          d="M 1136.5 1724 L 1137 1727.5 L 1136 1727.5 L 1136.5 1724 Z"
          fill="currentColor"
          fillOpacity="0.4588235"
          stroke="currentColor"
          strokeOpacity="0.4588235"
          strokeWidth="1"/>
        <path
          id="path_428"
          d="M 935.5 1727 L 936 1731.5 L 935 1731.5 L 935.5 1727 Z"
          fill="currentColor"
          fillOpacity="0.4588235"
          stroke="currentColor"
          strokeOpacity="0.4588235"
          strokeWidth="1"/>
        <path
          id="path_429"
          d="M 1137.5 1732 L 1138 1734.5 L 1137 1734.5 L 1137.5 1732 Z"
          fill="currentColor"
          fillOpacity="0.4588235"
          stroke="currentColor"
          strokeOpacity="0.4588235"
          strokeWidth="1"/>
        <path
          id="path_430"
          d="M 1664.5 1732 L 1665 1734.5 L 1664 1734.5 L 1664.5 1732 Z"
          fill="currentColor"
          fillOpacity="0.4588235"
          stroke="currentColor"
          strokeOpacity="0.4588235"
          strokeWidth="1"/>
        <path
          id="path_431"
          d="M 1295.5 1735 L 1296.5 1737 L 1295.5 1735 Z"
          fill="currentColor"
          fillOpacity="0.4588235"
          stroke="currentColor"
          strokeOpacity="0.4588235"
          strokeWidth="1"/>
        <path
          id="path_432"
          d="M 1865.5 1735 L 1866 1738.5 L 1865 1738.5 L 1865.5 1735 Z"
          fill="currentColor"
          fillOpacity="0.4588235"
          stroke="currentColor"
          strokeOpacity="0.4588235"
          strokeWidth="1"/>
        <path
          id="path_433"
          d="M 1505.5 1736 L 1504.5 1738 L 1505.5 1736 Z"
          fill="currentColor"
          fillOpacity="0.4588235"
          stroke="currentColor"
          strokeOpacity="0.4588235"
          strokeWidth="1"/>
        <path
          id="path_434"
          d="M 936.5 1737 L 937 1740.5 L 936 1740.5 L 936.5 1737 Z"
          fill="currentColor"
          fillOpacity="0.4588235"
          stroke="currentColor"
          strokeOpacity="0.4588235"
          strokeWidth="1"/>
        <path
          id="path_435"
          d="M 1663.5 1738 L 1664 1740.5 L 1663 1740.5 L 1663.5 1738 Z"
          fill="currentColor"
          fillOpacity="0.4588235"
          stroke="currentColor"
          strokeOpacity="0.4588235"
          strokeWidth="1"/>
        <path
          id="path_436"
          d="M 1299.5 1740 L 1301.5 1743 L 1299.5 1740 Z"
          fill="currentColor"
          fillOpacity="0.4588235"
          stroke="currentColor"
          strokeOpacity="0.4588235"
          strokeWidth="1"/>
        <path
          id="path_437"
          d="M 1499.5 1743 L 1496.5 1747 L 1499.5 1743 Z"
          fill="currentColor"
          fillOpacity="0.4588235"
          stroke="currentColor"
          strokeOpacity="0.4588235"
          strokeWidth="1"/>
        <path
          id="path_438"
          d="M 1864.5 1744 L 1865 1746.5 L 1864 1746.5 L 1864.5 1744 Z"
          fill="currentColor"
          fillOpacity="0.4588235"
          stroke="currentColor"
          strokeOpacity="0.4588235"
          strokeWidth="1"/>
        <path
          id="path_439"
          d="M 937.5 1746 L 938 1748.5 L 937 1748.5 L 937.5 1746 Z"
          fill="currentColor"
          fillOpacity="0.4588235"
          stroke="currentColor"
          strokeOpacity="0.4588235"
          strokeWidth="1"/>
        <path
          id="path_440"
          d="M 1493.5 1749 L 1490.5 1753 L 1493.5 1749 Z"
          fill="currentColor"
          fillOpacity="0.4588235"
          stroke="currentColor"
          strokeOpacity="0.4588235"
          strokeWidth="1"/>
        <path
          id="path_441"
          d="M 1863.5 1751 L 1864 1753.5 L 1863 1753.5 L 1863.5 1751 Z"
          fill="currentColor"
          fillOpacity="0.4588235"
          stroke="currentColor"
          strokeOpacity="0.4588235"
          strokeWidth="1"/>
        <path
          id="path_442"
          d="M 1311.5 1752 L 1313.5 1755 L 1311.5 1752 Z"
          fill="currentColor"
          fillOpacity="0.4588235"
          stroke="currentColor"
          strokeOpacity="0.4588235"
          strokeWidth="1"/>
        <path
          id="path_443"
          d="M 938.5 1753 L 939 1755.5 L 938 1755.5 L 938.5 1753 Z"
          fill="currentColor"
          fillOpacity="0.4588235"
          stroke="currentColor"
          strokeOpacity="0.4588235"
          strokeWidth="1"/>
        <path
          id="path_444"
          d="M 1484.5 1757 L 1483.5 1759 L 1484.5 1757 Z"
          fill="currentColor"
          fillOpacity="0.4588235"
          stroke="currentColor"
          strokeOpacity="0.4588235"
          strokeWidth="1"/>
        <path
          id="path_445"
          d="M 1318.5 1758 L 1319.5 1760 L 1318.5 1758 Z"
          fill="currentColor"
          fillOpacity="0.4588235"
          stroke="currentColor"
          strokeOpacity="0.4588235"
          strokeWidth="1"/>
        <path
          id="path_446"
          d="M 939.5 1759 L 940 1761.5 L 939 1761.5 L 939.5 1759 Z"
          fill="currentColor"
          fillOpacity="0.4588235"
          stroke="currentColor"
          strokeOpacity="0.4588235"
          strokeWidth="1"/>
        <path
          id="path_447"
          d="M 1480.5 1760 L 1479.5 1762 L 1480.5 1760 Z"
          fill="currentColor"
          fillOpacity="0.4588235"
          stroke="currentColor"
          strokeOpacity="0.4588235"
          strokeWidth="1"/>
        <path
          id="path_448"
          d="M 1325.5 1763 L 1326.5 1765 L 1325.5 1763 Z"
          fill="currentColor"
          fillOpacity="0.4588235"
          stroke="currentColor"
          strokeOpacity="0.4588235"
          strokeWidth="1"/>
        <path
          id="path_449"
          d="M 1328.5 1765 L 1329.5 1767 L 1328.5 1765 Z"
          fill="currentColor"
          fillOpacity="0.4588235"
          stroke="currentColor"
          strokeOpacity="0.4588235"
          strokeWidth="1"/>
        <path
          id="path_450"
          d="M 1420.5 1785 L 1423 1785.5 L 1420.5 1786 L 1420.5 1785 Z"
          fill="currentColor"
          fillOpacity="0.4588235"
          stroke="currentColor"
          strokeOpacity="0.4588235"
          strokeWidth="1"/>
        <path
          id="path_451"
          d="M 1386.5 1786 L 1390 1786.5 L 1386.5 1787 L 1386.5 1786 Z"
          fill="currentColor"
          fillOpacity="0.4588235"
          stroke="currentColor"
          strokeOpacity="0.4588235"
          strokeWidth="1"/>
        <path
          id="path_452"
          d="M 1411.5 1786 L 1416 1786.5 L 1411.5 1787 L 1411.5 1786 Z"
          fill="currentColor"
          fillOpacity="0.4588235"
          stroke="currentColor"
          strokeOpacity="0.4588235"
          strokeWidth="1"/>
        <path
          id="path_453"
          d="M 1620.5 1844 L 1619.5 1846 L 1620.5 1844 Z"
          fill="currentColor"
          fillOpacity="0.4588235"
          stroke="currentColor"
          strokeOpacity="0.4588235"
          strokeWidth="1"/>
        <path
          id="path_454"
          d="M 1185.5 1847 L 1186.5 1849 L 1185.5 1847 Z"
          fill="currentColor"
          fillOpacity="0.4588235"
          stroke="currentColor"
          strokeOpacity="0.4588235"
          strokeWidth="1"/>
        <path
          id="path_455"
          d="M 1611.5 1856 L 1610.5 1858 L 1611.5 1856 Z"
          fill="currentColor"
          fillOpacity="0.4588235"
          stroke="currentColor"
          strokeOpacity="0.4588235"
          strokeWidth="1"/>
        <path
          id="path_456"
          d="M 1606.5 1862 L 1604.5 1865 L 1606.5 1862 Z"
          fill="currentColor"
          fillOpacity="0.4588235"
          stroke="currentColor"
          strokeOpacity="0.4588235"
          strokeWidth="1"/>
        <path
          id="path_457"
          d="M 1198.5 1863 L 1200.5 1866 L 1198.5 1863 Z"
          fill="currentColor"
          fillOpacity="0.4588235"
          stroke="currentColor"
          strokeOpacity="0.4588235"
          strokeWidth="1"/>
        <path
          id="path_458"
          d="M 1595.5 1874 L 1590.5 1880 L 1595.5 1874 Z"
          fill="currentColor"
          fillOpacity="0.4588235"
          stroke="currentColor"
          strokeOpacity="0.4588235"
          strokeWidth="1"/>
        <path
          id="path_459"
          d="M 1220.5 1885 L 1222.5 1888 L 1220.5 1885 Z"
          fill="currentColor"
          fillOpacity="0.4588235"
          stroke="currentColor"
          strokeOpacity="0.4588235"
          strokeWidth="1"/>
        <path
          id="path_460"
          d="M 1580.5 1888 L 1579.5 1890 L 1580.5 1888 Z"
          fill="currentColor"
          fillOpacity="0.4588235"
          stroke="currentColor"
          strokeOpacity="0.4588235"
          strokeWidth="1"/>
        <path
          id="path_461"
          d="M 1228.5 1892 L 1229.5 1894 L 1228.5 1892 Z"
          fill="currentColor"
          fillOpacity="0.4588235"
          stroke="currentColor"
          strokeOpacity="0.4588235"
          strokeWidth="1"/>
        <path
          id="path_462"
          d="M 1574.5 1893 L 1573.5 1895 L 1574.5 1893 Z"
          fill="currentColor"
          fillOpacity="0.4588235"
          stroke="currentColor"
          strokeOpacity="0.4588235"
          strokeWidth="1"/>
        <path
          id="path_463"
          d="M 1233.5 1896 L 1234.5 1898 L 1233.5 1896 Z"
          fill="currentColor"
          fillOpacity="0.4588235"
          stroke="currentColor"
          strokeOpacity="0.4588235"
          strokeWidth="1"/>
        <path
          id="path_464"
          d="M 1569.5 1897 L 1568.5 1899 L 1569.5 1897 Z"
          fill="currentColor"
          fillOpacity="0.4588235"
          stroke="currentColor"
          strokeOpacity="0.4588235"
          strokeWidth="1"/>
        <path
          id="path_465"
          d="M 1237.5 1899 L 1238.5 1901 L 1237.5 1899 Z"
          fill="currentColor"
          fillOpacity="0.4588235"
          stroke="currentColor"
          strokeOpacity="0.4588235"
          strokeWidth="1"/>
        <path
          id="path_466"
          d="M 1241.5 1902 L 1242.5 1904 L 1241.5 1902 Z"
          fill="currentColor"
          fillOpacity="0.4588235"
          stroke="currentColor"
          strokeOpacity="0.4588235"
          strokeWidth="1"/>
        <path
          id="path_467"
          d="M 1561.5 1903 L 1560.5 1905 L 1561.5 1903 Z"
          fill="currentColor"
          fillOpacity="0.4588235"
          stroke="currentColor"
          strokeOpacity="0.4588235"
          strokeWidth="1"/>
        <path
          id="path_468"
          d="M 1549.5 1911 L 1548.5 1913 L 1549.5 1911 Z"
          fill="currentColor"
          fillOpacity="0.4588235"
          stroke="currentColor"
          strokeOpacity="0.4588235"
          strokeWidth="1"/>
        <path
          id="path_469"
          d="M 1256.5 1912 L 1257.5 1914 L 1256.5 1912 Z"
          fill="currentColor"
          fillOpacity="0.4588235"
          stroke="currentColor"
          strokeOpacity="0.4588235"
          strokeWidth="1"/>
        <path
          id="path_470"
          d="M 1804.5 1912 L 1803.5 1914 L 1804.5 1912 Z"
          fill="currentColor"
          fillOpacity="0.4588235"
          stroke="currentColor"
          strokeOpacity="0.4588235"
          strokeWidth="1"/>
        <path
          id="path_471"
          d="M 998.5 1914 L 999.5 1916 L 998.5 1914 Z"
          fill="currentColor"
          fillOpacity="0.4588235"
          stroke="currentColor"
          strokeOpacity="0.4588235"
          strokeWidth="1"/>
        <path
          id="path_472"
          d="M 1010.5 1932 L 1011.5 1934 L 1010.5 1932 Z"
          fill="currentColor"
          fillOpacity="0.4588235"
          stroke="currentColor"
          strokeOpacity="0.4588235"
          strokeWidth="1"/>
        <path
          id="path_473"
          d="M 1015.5 1939 L 1016.5 1941 L 1015.5 1939 Z"
          fill="currentColor"
          fillOpacity="0.4588235"
          stroke="currentColor"
          strokeOpacity="0.4588235"
          strokeWidth="1"/>
        <path
          id="path_474"
          d="M 1785.5 1940 L 1784.5 1942 L 1785.5 1940 Z"
          fill="currentColor"
          fillOpacity="0.4588235"
          stroke="currentColor"
          strokeOpacity="0.4588235"
          strokeWidth="1"/>
        <path
          id="path_475"
          d="M 1782.5 1944 L 1781.5 1946 L 1782.5 1944 Z"
          fill="currentColor"
          fillOpacity="0.4588235"
          stroke="currentColor"
          strokeOpacity="0.4588235"
          strokeWidth="1"/>
        <path
          id="path_476"
          d="M 1021.5 1947 L 1022.5 1949 L 1021.5 1947 Z"
          fill="currentColor"
          fillOpacity="0.4588235"
          stroke="currentColor"
          strokeOpacity="0.4588235"
          strokeWidth="1"/>
        <path
          id="path_477"
          d="M 1453.5 1948 L 1456 1948.5 L 1453.5 1949 L 1453.5 1948 Z"
          fill="currentColor"
          fillOpacity="0.4588235"
          stroke="currentColor"
          strokeOpacity="0.4588235"
          strokeWidth="1"/>
        <path
          id="path_478"
          d="M 1779.5 1948 L 1778.5 1950 L 1779.5 1948 Z"
          fill="currentColor"
          fillOpacity="0.4588235"
          stroke="currentColor"
          strokeOpacity="0.4588235"
          strokeWidth="1"/>
        <path
          id="path_479"
          d="M 1353.5 1949 L 1356 1949.5 L 1353.5 1950 L 1353.5 1949 Z"
          fill="currentColor"
          fillOpacity="0.4588235"
          stroke="currentColor"
          strokeOpacity="0.4588235"
          strokeWidth="1"/>
        <path
          id="path_480"
          d="M 1447.5 1949 L 1450 1949.5 L 1447.5 1950 L 1447.5 1949 Z"
          fill="currentColor"
          fillOpacity="0.4588235"
          stroke="currentColor"
          strokeOpacity="0.4588235"
          strokeWidth="1"/>
        <path
          id="path_481"
          d="M 1359.5 1950 L 1362 1950.5 L 1359.5 1951 L 1359.5 1950 Z"
          fill="currentColor"
          fillOpacity="0.4588235"
          stroke="currentColor"
          strokeOpacity="0.4588235"
          strokeWidth="1"/>
        <path
          id="path_482"
          d="M 1440.5 1950 L 1444 1950.5 L 1440.5 1951 L 1440.5 1950 Z"
          fill="currentColor"
          fillOpacity="0.4588235"
          stroke="currentColor"
          strokeOpacity="0.4588235"
          strokeWidth="1"/>
        <path
          id="path_483"
          d="M 1024.5 1951 L 1025.5 1953 L 1024.5 1951 Z"
          fill="currentColor"
          fillOpacity="0.4588235"
          stroke="currentColor"
          strokeOpacity="0.4588235"
          strokeWidth="1"/>
        <path
          id="path_484"
          d="M 1367.5 1951 L 1371 1951.5 L 1367.5 1952 L 1367.5 1951 Z"
          fill="currentColor"
          fillOpacity="0.4588235"
          stroke="currentColor"
          strokeOpacity="0.4588235"
          strokeWidth="1"/>
        <path
          id="path_485"
          d="M 1432.5 1951 L 1436 1951.5 L 1432.5 1952 L 1432.5 1951 Z"
          fill="currentColor"
          fillOpacity="0.4588235"
          stroke="currentColor"
          strokeOpacity="0.4588235"
          strokeWidth="1"/>
        <path
          id="path_486"
          d="M 1376.5 1952 L 1383 1952.5 L 1376.5 1953 L 1376.5 1952 Z"
          fill="currentColor"
          fillOpacity="0.4588235"
          stroke="currentColor"
          strokeOpacity="0.4588235"
          strokeWidth="1"/>
        <path
          id="path_487"
          d="M 1420.5 1952 L 1426 1952.5 L 1420.5 1953 L 1420.5 1952 Z"
          fill="currentColor"
          fillOpacity="0.4588235"
          stroke="currentColor"
          strokeOpacity="0.4588235"
          strokeWidth="1"/>
        <path
          id="path_488"
          d="M 1395.5 1953 L 1407 1953.5 L 1395.5 1954 L 1395.5 1953 Z"
          fill="currentColor"
          fillOpacity="0.4588235"
          stroke="currentColor"
          strokeOpacity="0.4588235"
          strokeWidth="1"/>
        <path
          id="path_489"
          d="M 1028.5 1956 L 1029.5 1958 L 1028.5 1956 Z"
          fill="currentColor"
          fillOpacity="0.4588235"
          stroke="currentColor"
          strokeOpacity="0.4588235"
          strokeWidth="1"/>
        <path
          id="path_490"
          d="M 1772.5 1957 L 1771.5 1959 L 1772.5 1957 Z"
          fill="currentColor"
          fillOpacity="0.4588235"
          stroke="currentColor"
          strokeOpacity="0.4588235"
          strokeWidth="1"/>
        <path
          id="path_491"
          d="M 1033.5 1962 L 1034.5 1964 L 1033.5 1962 Z"
          fill="currentColor"
          fillOpacity="0.4588235"
          stroke="currentColor"
          strokeOpacity="0.4588235"
          strokeWidth="1"/>
        <path
          id="path_492"
          d="M 1767.5 1963 L 1766.5 1965 L 1767.5 1963 Z"
          fill="currentColor"
          fillOpacity="0.4588235"
          stroke="currentColor"
          strokeOpacity="0.4588235"
          strokeWidth="1"/>
        <path
          id="path_493"
          d="M 1038.5 1968 L 1039.5 1970 L 1038.5 1968 Z"
          fill="currentColor"
          fillOpacity="0.4588235"
          stroke="currentColor"
          strokeOpacity="0.4588235"
          strokeWidth="1"/>
        <path
          id="path_494"
          d="M 1761.5 1970 L 1760.5 1972 L 1761.5 1970 Z"
          fill="currentColor"
          fillOpacity="0.4588235"
          stroke="currentColor"
          strokeOpacity="0.4588235"
          strokeWidth="1"/>
        <path
          id="path_495"
          d="M 1045.5 1976 L 1047.5 1979 L 1045.5 1976 Z"
          fill="currentColor"
          fillOpacity="0.4588235"
          stroke="currentColor"
          strokeOpacity="0.4588235"
          strokeWidth="1"/>
        <path
          id="path_496"
          d="M 1753.5 1979 L 1750.5 1983 L 1753.5 1979 Z"
          fill="currentColor"
          fillOpacity="0.4588235"
          stroke="currentColor"
          strokeOpacity="0.4588235"
          strokeWidth="1"/>
        <path
          id="path_497"
          d="M 1728.5 2004 L 1725.5 2008 L 1728.5 2004 Z"
          fill="currentColor"
          fillOpacity="0.4588235"
          stroke="currentColor"
          strokeOpacity="0.4588235"
          strokeWidth="1"/>
        <path
          id="path_498"
          d="M 1077.5 2008 L 1079.5 2011 L 1077.5 2008 Z"
          fill="currentColor"
          fillOpacity="0.4588235"
          stroke="currentColor"
          strokeOpacity="0.4588235"
          strokeWidth="1"/>
        <path
          id="path_499"
          d="M 1717.5 2014 L 1715.5 2017 L 1717.5 2014 Z"
          fill="currentColor"
          fillOpacity="0.4588235"
          stroke="currentColor"
          strokeOpacity="0.4588235"
          strokeWidth="1"/>
        <path
          id="path_500"
          d="M 1086.5 2016 L 1087.5 2018 L 1086.5 2016 Z"
          fill="currentColor"
          fillOpacity="0.4588235"
          stroke="currentColor"
          strokeOpacity="0.4588235"
          strokeWidth="1"/>
        <path
          id="path_501"
          d="M 1710.5 2020 L 1709.5 2022 L 1710.5 2020 Z"
          fill="currentColor"
          fillOpacity="0.4588235"
          stroke="currentColor"
          strokeOpacity="0.4588235"
          strokeWidth="1"/>
        <path
          id="path_502"
          d="M 1093.5 2022 L 1094.5 2024 L 1093.5 2022 Z"
          fill="currentColor"
          fillOpacity="0.4588235"
          stroke="currentColor"
          strokeOpacity="0.4588235"
          strokeWidth="1"/>
        <path
          id="path_503"
          d="M 1704.5 2025 L 1703.5 2027 L 1704.5 2025 Z"
          fill="currentColor"
          fillOpacity="0.4588235"
          stroke="currentColor"
          strokeOpacity="0.4588235"
          strokeWidth="1"/>
        <path
          id="path_504"
          d="M 1098.5 2026 L 1099.5 2028 L 1098.5 2026 Z"
          fill="currentColor"
          fillOpacity="0.4588235"
          stroke="currentColor"
          strokeOpacity="0.4588235"
          strokeWidth="1"/>
        <path
          id="path_505"
          d="M 1699.5 2029 L 1698.5 2031 L 1699.5 2029 Z"
          fill="currentColor"
          fillOpacity="0.4588235"
          stroke="currentColor"
          strokeOpacity="0.4588235"
          strokeWidth="1"/>
        <path
          id="path_506"
          d="M 1103.5 2030 L 1104.5 2032 L 1103.5 2030 Z"
          fill="currentColor"
          fillOpacity="0.4588235"
          stroke="currentColor"
          strokeOpacity="0.4588235"
          strokeWidth="1"/>
        <path
          id="path_507"
          d="M 1694.5 2033 L 1693.5 2035 L 1694.5 2033 Z"
          fill="currentColor"
          fillOpacity="0.4588235"
          stroke="currentColor"
          strokeOpacity="0.4588235"
          strokeWidth="1"/>
        <path
          id="path_508"
          d="M 1690.5 2036 L 1689.5 2038 L 1690.5 2036 Z"
          fill="currentColor"
          fillOpacity="0.4588235"
          stroke="currentColor"
          strokeOpacity="0.4588235"
          strokeWidth="1"/>
        <path
          id="path_509"
          d="M 1112.5 2037 L 1113.5 2039 L 1112.5 2037 Z"
          fill="currentColor"
          fillOpacity="0.4588235"
          stroke="currentColor"
          strokeOpacity="0.4588235"
          strokeWidth="1"/>
        <path
          id="path_510"
          d="M 1686.5 2039 L 1685.5 2041 L 1686.5 2039 Z"
          fill="currentColor"
          fillOpacity="0.4588235"
          stroke="currentColor"
          strokeOpacity="0.4588235"
          strokeWidth="1"/>
        <path
          id="path_511"
          d="M 1679.5 2044 L 1678.5 2046 L 1679.5 2044 Z"
          fill="currentColor"
          fillOpacity="0.4588235"
          stroke="currentColor"
          strokeOpacity="0.4588235"
          strokeWidth="1"/>
        <path
          id="path_512"
          d="M 1126.5 2047 L 1127.5 2049 L 1126.5 2047 Z"
          fill="currentColor"
          fillOpacity="0.4588235"
          stroke="currentColor"
          strokeOpacity="0.4588235"
          strokeWidth="1"/>
        <path
          id="path_513"
          d="M 1483.5 2126 L 1486 2126.5 L 1483.5 2127 L 1483.5 2126 Z"
          fill="currentColor"
          fillOpacity="0.4588235"
          stroke="currentColor"
          strokeOpacity="0.4588235"
          strokeWidth="1"/>
        <path
          id="path_514"
          d="M 1477.5 2127 L 1480 2127.5 L 1477.5 2128 L 1477.5 2127 Z"
          fill="currentColor"
          fillOpacity="0.4588235"
          stroke="currentColor"
          strokeOpacity="0.4588235"
          strokeWidth="1"/>
        <path
          id="path_515"
          d="M 1328.5 2128 L 1331 2128.5 L 1328.5 2129 L 1328.5 2128 Z"
          fill="currentColor"
          fillOpacity="0.4588235"
          stroke="currentColor"
          strokeOpacity="0.4588235"
          strokeWidth="1"/>
        <path
          id="path_516"
          d="M 1471.5 2128 L 1474 2128.5 L 1471.5 2129 L 1471.5 2128 Z"
          fill="currentColor"
          fillOpacity="0.4588235"
          stroke="currentColor"
          strokeOpacity="0.4588235"
          strokeWidth="1"/>
        <path
          id="path_517"
          d="M 1335.5 2129 L 1338 2129.5 L 1335.5 2130 L 1335.5 2129 Z"
          fill="currentColor"
          fillOpacity="0.4588235"
          stroke="currentColor"
          strokeOpacity="0.4588235"
          strokeWidth="1"/>
        <path
          id="path_518"
          d="M 1464.5 2129 L 1467 2129.5 L 1464.5 2130 L 1464.5 2129 Z"
          fill="currentColor"
          fillOpacity="0.4588235"
          stroke="currentColor"
          strokeOpacity="0.4588235"
          strokeWidth="1"/>
        <path
          id="path_519"
          d="M 1343.5 2130 L 1346 2130.5 L 1343.5 2131 L 1343.5 2130 Z"
          fill="currentColor"
          fillOpacity="0.4588235"
          stroke="currentColor"
          strokeOpacity="0.4588235"
          strokeWidth="1"/>
        <path
          id="path_520"
          d="M 1456.5 2130 L 1459 2130.5 L 1456.5 2131 L 1456.5 2130 Z"
          fill="currentColor"
          fillOpacity="0.4588235"
          stroke="currentColor"
          strokeOpacity="0.4588235"
          strokeWidth="1"/>
        <path
          id="path_521"
          d="M 1351.5 2131 L 1356 2131.5 L 1351.5 2132 L 1351.5 2131 Z"
          fill="currentColor"
          fillOpacity="0.4588235"
          stroke="currentColor"
          strokeOpacity="0.4588235"
          strokeWidth="1"/>
        <path
          id="path_522"
          d="M 1446.5 2131 L 1450 2131.5 L 1446.5 2132 L 1446.5 2131 Z"
          fill="currentColor"
          fillOpacity="0.4588235"
          stroke="currentColor"
          strokeOpacity="0.4588235"
          strokeWidth="1"/>
        <path
          id="path_523"
          d="M 1362.5 2132 L 1368 2132.5 L 1362.5 2133 L 1362.5 2132 Z"
          fill="currentColor"
          fillOpacity="0.4588235"
          stroke="currentColor"
          strokeOpacity="0.4588235"
          strokeWidth="1"/>
        <path
          id="path_524"
          d="M 1433.5 2132 L 1440 2132.5 L 1433.5 2133 L 1433.5 2132 Z"
          fill="currentColor"
          fillOpacity="0.4588235"
          stroke="currentColor"
          strokeOpacity="0.4588235"
          strokeWidth="1"/>
        <path
          id="path_525"
          d="M 1377.5 2133 L 1391 2133.5 L 1377.5 2134 L 1377.5 2133 Z"
          fill="currentColor"
          fillOpacity="0.4588235"
          stroke="currentColor"
          strokeOpacity="0.4588235"
          strokeWidth="1"/>
        <path
          id="path_526"
          d="M 1410.5 2133 L 1424 2133.5 L 1410.5 2134 L 1410.5 2133 Z"
          fill="currentColor"
          fillOpacity="0.4588235"
          stroke="currentColor"
          strokeOpacity="0.4588235"
          strokeWidth="1"/>
      </g>
    </svg>

  </React.Fragment>
)

const icon = createSvgIcon(fragment, 'SconceLights')

export default icon
